// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* poppins-thin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 100;
  src: local("Poppins Thin"), local("Poppins-Thin"), url('Poppins-Thin.d1ebd0909fb09ae7.woff2') format("woff2"), url('Poppins-Thin.dd1122e1b1a539ba.woff') format("woff"), url('Poppins-Thin.605324f7af12a99a.ttf') format("truetype");
}
/* poppins-thinItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 100;
  src: local("Poppins Thin Italic"), local("Poppins-ThinItalic"), url('Poppins-ThinItalic.75b2c7a7cc89ee66.woff2') format("woff2"), url('Poppins-ThinItalic.c1bf62dcccbac3a0.woff') format("woff"), url('Poppins-ThinItalic.ef8911147e9862d8.ttf') format("truetype");
}
/* poppins-extraLight */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 200;
  src: local("Poppins ExtraLight"), local("Poppins-ExtraLight"), url('Poppins-ExtraLight.159bee76e56bb451.woff2') format("woff2"), url('Poppins-ExtraLight.5ffd17e35afb412b.woff') format("woff"), url('Poppins-ExtraLight.9102fb8415d8f327.ttf') format("truetype");
}
/* poppins-extraLightItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 200;
  src: local("Poppins ExtraLight Italic"), local("Poppins-ExtraLightItalic"), url('Poppins-ExtraLightItalic.14b0d925e89d6e48.woff2') format("woff2"), url('Poppins-ExtraLightItalic.39e591d1f61f409e.woff') format("woff"), url('Poppins-ExtraLightItalic.2ce504459899a1d8.ttf') format("truetype");
}
/* poppins-light */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: local("Poppins Light"), local("Poppins-Light"), url('Poppins-Light.25bc69abf2f42981.woff2') format("woff2"), url('Poppins-Light.4b4de4cb1f542d71.woff') format("woff"), url('Poppins-Light.8b20023e8f811f53.ttf') format("truetype");
}
/* poppins-lightItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 300;
  src: local("Poppins Light Italic"), local("Poppins-LightItalic"), url('Poppins-LightItalic.3263b3d7cd700d7b.woff2') format("woff2"), url('Poppins-LightItalic.517a7c751b2c1b49.woff') format("woff"), url('Poppins-LightItalic.acd7f79f9e69ead8.ttf') format("truetype");
}
/* poppins-regular */
@font-face {
  font-family: "Poppins";
  line-height: 1rem;
  font-style: normal;
  font-weight: 400;
  src: local("Poppins Regular"), local("Poppins-Regular"), url('Poppins-Regular.e2439514cfc3a299.woff2') format("woff2"), url('Poppins-Regular.3b9bbe9a5e6e25e0.woff') format("woff"), url('Poppins-Regular.4b4ebe20759bdbf2.ttf') format("truetype");
}
/* poppins-italic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 400;
  src: local("Poppins Italic"), local("Poppins-Italic"), url('Poppins-Italic.4cd5f1499e1bc9c1.woff2') format("woff2"), url('Poppins-Italic.d54e5d17b51c8b12.woff') format("woff"), url('Poppins-Italic.b2efb5cde74c2f1a.ttf') format("truetype");
}
/* poppins-medium */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: local("Poppins Medium"), local("Poppins-Medium"), url('Poppins-Medium.34f732e4005c0b06.woff2') format("woff2"), url('Poppins-Medium.4fdd9f946614e719.woff') format("woff"), url('Poppins-Medium.a52d0bf095c248da.ttf') format("truetype");
}
/* poppins-mediumItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 500;
  src: local("Poppins Medium Italic"), local("Poppins-MediumItalic"), url('Poppins-MediumItalic.d251d5de8fe67201.woff2') format("woff2"), url('Poppins-MediumItalic.f2190b2394e74fdf.woff') format("woff"), url('Poppins-MediumItalic.34a634e1e94d3514.ttf') format("truetype");
}
/* poppins-semiBold */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  src: local("Poppins SemiBold"), local("Poppins-SemiBold"), url('Poppins-SemiBold.5e3468584976ac94.woff2') format("woff2"), url('Poppins-SemiBold.1b1ad528fafa8079.woff') format("woff"), url('Poppins-SemiBold.98512bf8da1afe43.ttf') format("truetype");
}
/* poppins-semiBoldItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 600;
  src: local("Poppins SemiBold Italic"), local("Poppins-SemiBoldItalic"), url('Poppins-SemiBoldItalic.c00e2c5d1af804c9.woff2') format("woff2"), url('Poppins-SemiBoldItalic.e3e2392489d1635f.woff') format("woff"), url('Poppins-SemiBoldItalic.502635913515117a.ttf') format("truetype");
}
/* poppins-bold */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: local("Poppins Bold"), local("Poppins-Bold"), url('Poppins-Bold.2a9780f4c4a55304.woff2') format("woff2"), url('Poppins-Bold.f362f7b1141be5ee.woff') format("woff"), url('Poppins-Bold.8001a01b32b71ef5.ttf') format("truetype");
}
/* poppins-boldItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 700;
  src: local("Poppins Bold Italic"), local("Poppins-BoldItalic"), url('Poppins-BoldItalic.aa8ce9773a0189cb.woff2') format("woff2"), url('Poppins-BoldItalic.6b60b1b9aa304a4a.woff') format("woff"), url('Poppins-BoldItalic.1a15c5ce3e29c0a9.ttf') format("truetype");
}
/* poppins-black */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 900;
  src: local("Poppins Black"), local("Poppins-Black"), url('Poppins-Black.71aa7262e2aa69bb.woff2') format("woff2"), url('Poppins-Black.1ad1e5afc205ad1a.woff') format("woff"), url('Poppins-Black.a7317f18e35bd6ef.ttf') format("truetype");
}
/* poppins-blackItalic */
@font-face {
  font-family: "Poppins";
  font-style: italic;
  font-weight: 900;
  src: local("Poppins Black Italic"), local("Poppins-BlackItalic"), url('Poppins-BlackItalic.a26e72052c8a6acc.woff2') format("woff2"), url('Poppins-BlackItalic.3bc8971ac2f6737d.woff') format("woff"), url('Poppins-BlackItalic.0719401c96a043e7.ttf') format("truetype");
}
@keyframes px-mask-in {
  from {
    background-color: transparent;
  }
  to {
    background-color: var(--maskbg);
  }
}
@keyframes px-scalein {
  0% {
    opacity: 0;
    transform: scaleY(0.8);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes px-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes px-fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.px-scalein {
  animation: px-scalein 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.px-fadein {
  animation: px-fadein 0.15s linear;
}

.px-fadeout {
  animation: px-fadeout 0.15s linear;
}

.layout-light {
  --sidebar-shadow: 0px 4px 50px #D9DDFC;
  --sidebar-border: 1px solid transparent;
  --card-shadow: 0px 4px 30px rgba(221, 224, 255, 0.54);
  --body-bg: #F2F2F2;
  --body-image: url("/assets/layout/images/effect-onlight.png");
  --root-menu-item-hover-bg: rgba(68, 72, 109, 0.07);
  --exception-pages-image: url("/assets/layout/images/pages/exception-onlight.png");
}

.layout-dark {
  --sidebar-shadow: none;
  --sidebar-border: 1px solid var(--surface-border);
  --card-shadow: none;
  --body-bg:linear-gradient(180deg, #2E323F 0%, #0A061A 100%) ;
  --body-image: url("/assets/layout/images/effect-ondark.png");
  --root-menu-item-hover-bg:rgba(255, 255, 255, 0.05);
  --exception-pages-image: url("/assets/layout/images/pages/exception-ondark.png");
}

* {
  box-sizing: border-box;
}

html {
  height: 100%;
  font-size: 14px;
}

body {
  font-weight: 400;
  padding: 0;
  margin: 0;
  min-height: 100%;
  color: var(--text-color);
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a,
a:visited {
  color: inherit;
  text-decoration: none;
}

.layout-container {
  background: var(--body-bg);
  min-height: 100vh;
}
.layout-container:before {
  min-height: 100vh;
  height: 100%;
  width: 100%;
  content: "";
  z-index: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-image: var(--body-image);
  background-repeat: no-repeat;
  z-index: 0;
}
.layout-container .layout-content-wrapper {
  position: relative;
  z-index: 1;
}

.DC--card {
  background-color: var(--surface-section);
  border-radius: 0.8rem;
  padding: 0.5rem;
}

.DC--title {
  font-weight: 900;
  color: #545c64;
}

.DC--title2 {
  font-weight: 600;
  color: #545c64;
}

.dc--btn-primary {
  background-color: var(--primary-color);
  color: white;
  border: 1px solid var(--primary-color);
  transition: background-color 0.3s, color 0.3s;
  border-radius: 6px;
  cursor: pointer;
}
.dc--btn-primary:hover {
  background-color: #d61058;
  border-color: #d61058;
  color: white;
}
.dc--btn-primary:active {
  background-color: #af003d;
  border-color: #af003d;
}

.dc--btn-secondary {
  background-color: white;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  transition: background-color 0.3s, color 0.3s;
  border-radius: 6px;
  cursor: pointer;
}
.dc--btn-secondary:hover {
  background-color: white;
  border-color: #d61058;
  color: #d61058;
}
.dc--btn-secondary:active {
  background-color: white;
  border-color: #af003d;
}

.dc--btn-tertiary {
  background-color: transparent;
  color: var(--text-color);
  font-size: 1rem !important;
  font-weight: 600;
  border: 0 solid transparent;
  transition: background-color 0.3s, color 0.3s;
  cursor: pointer;
}
.dc--btn-tertiary:hover {
  color: #6a737c;
}
.p-scrollpanel .p-scrollpanel-bar {
  background-color: rgba(68, 72, 109, 0.15) !important;
}

.p-treetable .p-treetable-tfoot > tr > td {
  border: none !important;
}

::-webkit-scrollbar {
  width: 6px;
  margin-left: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #dadada;
  /* Color of the scrollbar handle */
  border-radius: 5px;
  /* Rounded corners */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c0bebe;
  /* Change color on hover */
}

.layout-sidebar {
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  width: 16rem;
  display: flex;
  flex-direction: column;
  border-radius: 0px 40px 40px 0px;
}
.layout-sidebar .material-symbols-outlined {
  font-size: 20px;
}
.layout-sidebar .sidebar-header {
  padding: 1.7rem 1.57rem 0.5rem 2.42rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.layout-sidebar .sidebar-header .app-logo {
  margin-left: -0.6rem;
  width: 100%;
}
.layout-sidebar .sidebar-header .app-logo .app-logo-normal {
  display: inline;
}
.layout-sidebar .sidebar-header .app-logo .app-logo-normal img {
  height: 1.714rem;
  border: 0 none;
}
.layout-sidebar .sidebar-header .app-logo .app-logo-small {
  display: none;
}
.layout-sidebar .sidebar-header .app-logo .app-logo-small img {
  height: 2.5rem;
  border: 0 none;
}
.layout-sidebar .layout-menu-container {
  overflow: auto;
  flex: 1;
  padding-bottom: 2rem;
}
.layout-sidebar .layout-menu {
  margin: 0;
  padding: 0 1.5rem;
  list-style-type: none;
}
.layout-sidebar .layout-menu > li {
  margin-bottom: 2.25rem;
}
.layout-sidebar .layout-menu > li:first-child {
  margin-top: 2rem;
}
.layout-sidebar .layout-menu li {
  border-radius: 8px;
}
.layout-sidebar .layout-menu li a {
  border-left: 8px solid transparent;
}
.layout-sidebar .layout-menu .layout-root-menuitem > div {
  padding-left: 1.5rem;
  margin-bottom: 0.5rem;
  font-size: 12px;
}
.layout-sidebar .layout-menu .layout-root-menuitem > div > .layout-menuitem-text {
  font-size: 0.857rem;
  font-weight: 600;
  text-transform: uppercase;
}
.layout-sidebar .layout-menu .layout-root-menuitem > a {
  display: none;
}
.layout-sidebar .layout-menu a {
  -webkit-user-select: none;
          user-select: none;
}
.layout-sidebar .layout-menu a.active-menuitem > .layout-submenu-toggler {
  transform: rotate(-180deg);
}
.layout-sidebar .layout-menu li.active-menuitem {
  background-color: var(--root-menu-item-hover-bg);
}
.layout-sidebar .layout-menu li.active-menuitem > a {
  border-left-color: var(--primary-color);
  background-color: var(--root-menu-item-hover-bg);
}
.layout-sidebar .layout-menu li.active-menuitem > a .layout-submenu-toggler {
  transform: rotate(-180deg);
}
.layout-sidebar .layout-menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.layout-sidebar .layout-menu ul a {
  display: flex;
  align-items: center;
  position: relative;
  outline: 0 none;
  color: var(--text-color);
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: background-color var(--transition-duration), box-shadow var(--transition-duration);
}
.layout-sidebar .layout-menu ul a .layout-menuitem-icon {
  margin-right: 0.5rem;
}
.layout-sidebar .layout-menu ul a .layout-submenu-toggler {
  font-size: 75%;
  margin-left: auto;
  transition: transform var(--transition-duration);
}
.layout-sidebar .layout-menu ul a.active-route {
  border-left-color: var(--primary-color);
  background-color: var(--root-menu-item-hover-bg);
}
.layout-sidebar .layout-menu ul a:hover {
  background-color: var(--root-menu-item-hover-bg);
}
.layout-sidebar .layout-menu ul ul {
  overflow: hidden;
  border-radius: var(--border-radius);
}
.layout-sidebar .layout-menu ul ul li a {
  padding-left: 2.5rem;
}
.layout-sidebar .layout-menu ul ul li li a {
  padding-left: 3rem;
}
.layout-sidebar .layout-menu ul ul li li li a {
  padding-left: 3.5rem;
}
.layout-sidebar .layout-menu ul ul li li li li a {
  padding-left: 4rem;
}
.layout-sidebar .layout-menu ul ul li li li li li a {
  padding-left: 5.5rem;
}
.layout-sidebar .layout-menu ul ul li li li li li li a {
  padding-left: 5rem;
}

@media screen and (min-width: 992px) {
  .layout-container.layout-slim .layout-topbar .topbar-menubutton {
    display: none;
  }
  .layout-container.layout-slim .sidebar-header {
    padding: 1.7rem 0;
  }
  .layout-container.layout-slim .sidebar-header .app-logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .layout-container.layout-slim .sidebar-header .app-logo .app-logo-normal {
    display: none;
  }
  .layout-container.layout-slim .sidebar-header .app-logo .app-logo-normal img {
    height: 1.714rem;
  }
  .layout-container.layout-slim .sidebar-header .app-logo .app-logo-small {
    display: inline;
  }
  .layout-container.layout-slim .sidebar-header .app-logo .app-logo-small img {
    height: 2.5rem;
  }
  .layout-container.layout-slim .layout-sidebar {
    width: 5.857rem;
    overflow: visible;
    z-index: 999;
  }
  .layout-container.layout-slim .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-slim .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim .layout-content-wrapper {
    margin-left: 5.857rem;
  }
  .layout-container.layout-slim .layout-menu {
    padding: 0 1rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    outline: none;
    transition: background-color var(--transition-duration);
    margin: 0px;
    padding: 8px;
    width: 40px;
    height: 40px;
    margin: 0 auto 1rem auto;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a:hover {
    color: --primary-color-text;
    background-color: var(--primary-color);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 5.857rem;
    top: 0;
    min-width: 15rem;
    background: var(--surface-ground);
    border-radius: var(--border-radius);
    box-shadow: var(--sidebar-shadow);
    padding: 0.5rem;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
    color: var(--text-color);
    border-radius: var(--border-radius);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul a .layout-menuitem-icon {
    color: var(--text-color);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul a:hover {
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-slim-plus .layout-topbar .topbar-menubutton {
    display: none;
  }
  .layout-container.layout-slim-plus .sidebar-header {
    justify-content: center;
    padding: 1.7rem 0;
  }
  .layout-container.layout-slim-plus .sidebar-header .app-logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .layout-container.layout-slim-plus .sidebar-header .app-logo .app-logo-normal {
    display: none;
  }
  .layout-container.layout-slim-plus .sidebar-header .app-logo .app-logo-small {
    display: inline;
    align-items: center;
  }
  .layout-container.layout-slim-plus .layout-sidebar {
    width: 8rem;
    overflow: visible;
    z-index: 999;
  }
  .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-content-wrapper {
    margin-left: 8rem;
  }
  .layout-container.layout-slim-plus .layout-menu {
    padding: 0 1rem;
  }
  .layout-container.layout-slim-plus .layout-menu ul {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu li.active-menuitem > ul {
    display: block;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    text-align: center;
    cursor: pointer;
    border: none;
    outline: none;
    transition: background-color var(--transition-duration);
    width: auto;
    height: auto;
    margin: 0 auto 1rem auto;
    padding: 8px;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
    color: var(--text-color);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-top: 0.25rem;
    color: var(--text-color);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 8rem;
    top: 0;
    min-width: 15rem;
    background: var(--surface-ground);
    border-radius: var(--border-radius);
    box-shadow: var(--sidebar-shadow);
    padding: 0.5rem;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
    color: var(--text-color);
    border-radius: var(--border-radius);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul a .layout-menuitem-icon {
    color: var(--text-color);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul a:hover {
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-horizontal .layout-topbar .topbar-menubutton {
    display: none;
  }
  .layout-container.layout-horizontal .layout-topbar .layout-topbar-menu-section {
    width: calc(100% - 320px);
  }
  .layout-container.layout-horizontal .layout-topbar .topbar-breadcrumb {
    display: none;
  }
  .layout-container.layout-horizontal .layout-sidebar {
    width: auto;
    height: auto;
    top: 0;
    z-index: 999;
    overflow: visible;
    flex-direction: row;
    position: static;
  }
  .layout-container.layout-horizontal .layout-sidebar .layout-menu-container {
    overflow: auto;
    padding-bottom: 0;
  }
  .layout-container.layout-horizontal .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-horizontal .layout-sidebar .sidebar-header {
    padding: 0;
  }
  .layout-container.layout-horizontal .layout-sidebar .sidebar-header .app-logo .app-logo-normal {
    display: none;
  }
  .layout-container.layout-horizontal .layout-sidebar .sidebar-header .app-logo .app-logo-small {
    display: inline;
  }
  .layout-container.layout-horizontal .layout-menu {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0 1rem;
  }
  .layout-container.layout-horizontal .layout-menu > li {
    margin-bottom: 0rem;
  }
  .layout-container.layout-horizontal .layout-menu > li:first-child {
    margin-top: 0rem;
  }
  .layout-container.layout-horizontal .layout-menu ul {
    display: none;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem {
    border-radius: var(--border-radius);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    outline: none;
    color: var(--text-color);
    transition: background-color var(--transition-duration);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: block;
    margin-left: auto;
    transition: transform 0.2s;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    white-space: nowrap;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg-color);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: auto;
    top: 5rem;
    min-width: 15rem;
    background: var(--surface-overlay);
    box-shadow: var(--sidebar-shadow);
    padding: 0.8rem;
    border-radius: var(--border-radius);
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
    color: var(--text-color);
    border-radius: var(--border-radius);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul a:hover {
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-reveal .layout-topbar .topbar-menubutton {
    display: none;
  }
  .layout-container.layout-reveal .layout-sidebar {
    height: 100%;
    top: 0;
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
    transform: translateX(-15.5rem);
    z-index: 999;
    background: var(--surface-ground);
    padding-bottom: 3rem;
  }
  .layout-container.layout-reveal .layout-sidebar .sidebar-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 1rem;
    height: 5.71rem;
  }
  .layout-container.layout-reveal .layout-sidebar .sidebar-header .app-logo {
    text-align: right;
  }
  .layout-container.layout-reveal .layout-sidebar .sidebar-header .app-logo .app-logo-small {
    display: inline;
    order: 1;
    margin-right: 0.5rem;
  }
  .layout-container.layout-reveal .layout-sidebar .sidebar-header .app-logo .app-logo-normal {
    display: none;
  }
  .layout-container.layout-reveal .layout-sidebar .sidebar-header .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
    background-color: transparent;
    transition: background-color var(--transition-duration), transform 0.3s;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-right: 0.125rem;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu ul a {
    padding: 0.5rem 1rem;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu ul a .layout-menuitem-text {
    order: 1;
    margin-right: auto;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu ul a .layout-submenu-toggler {
    order: 2;
    display: none;
    margin-right: 0.5rem;
  }
  .layout-container.layout-reveal .layout-sidebar .layout-menu ul a .layout-menuitem-icon {
    order: 3;
    margin-right: 0;
    font-size: 1rem;
    width: auto;
  }
  .layout-container.layout-reveal.layout-reveal .layout-content-wrapper {
    margin-left: 4.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar {
    padding-bottom: 0rem;
    transform: translateX(0);
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .sidebar-header {
    padding: 1.5rem 2rem;
    justify-content: space-between;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo {
    text-align: left;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-normal {
    display: inline;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-small {
    display: none;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .sidebar-header .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: none;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul {
    overflow: hidden;
    border-radius: var(--border-radius);
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li a {
    padding-left: 3rem;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li a {
    padding-left: 3.5rem;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li a {
    padding-left: 4rem;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li li a {
    padding-left: 5.5rem;
  }
  .layout-container.layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li li li a {
    padding-left: 5rem;
  }
  .layout-container.layout-reveal.layout-sidebar-anchored .sidebar-header .layout-sidebar-anchor {
    background-color: var(--primary-color);
  }
  .layout-container.layout-reveal.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 22rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-drawer .layout-topbar .topbar-menubutton {
    display: none;
  }
  .layout-container.layout-drawer .layout-sidebar {
    height: 100%;
    top: 0;
    transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: 6rem;
    z-index: 999;
    background: var(--surface-ground);
    padding-bottom: 3rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header {
    display: flex;
    justify-content: center;
    gap: 1rem;
    padding: 1.5rem 0rem;
    height: 5.71rem;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header .app-logo {
    text-align: center;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header .app-logo .app-logo-small {
    display: inline;
    order: 1;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header .app-logo .app-logo-normal {
    display: flex;
    align-items: center;
    width: 0;
    transition: width 0.1s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 50ms;
    max-width: 0;
    height: 0;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header .app-logo .app-logo-normal img {
    width: 0;
    transition: width 0.1s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 50ms;
    max-width: 0;
  }
  .layout-container.layout-drawer .layout-sidebar .sidebar-header .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
    background-color: transparent;
    transition: background-color var(--transition-duration), transform 0.3s;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu {
    transition: all 0.4s;
    padding: 0 1rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text .layout-menuitem-icon {
    font-size: 1rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-right: 0.125rem;
    font-size: 1.25rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu ul {
    margin: 0 auto;
    padding: 0;
    list-style-type: none;
    width: 3rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu ul a {
    border: none;
    width: 3rem;
    padding: 0.5rem 1rem;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu ul a span {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  .layout-container.layout-drawer .layout-sidebar .layout-menu ul a .layout-menuitem-icon {
    font-size: 1rem;
  }
  .layout-container.layout-drawer.layout-drawer .layout-content-wrapper {
    margin-left: 5.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
    overflow-x: hidden;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar {
    width: 22rem;
    padding-bottom: 0rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header {
    padding: 1.5rem 2rem;
    justify-content: space-between;
    height: 5.71rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo {
    text-align: left;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-normal {
    height: auto;
    width: 100%;
    max-width: none;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-normal img:first-child {
    width: 32px;
    max-width: none;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-normal img:last-child {
    width: 142px;
    max-width: none;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .app-logo .app-logo-small {
    display: none;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .sidebar-header .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu {
    padding: 0 1rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu li {
    border-radius: 8px;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu li a {
    border-left: 8px solid transparent;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu li.active-menuitem {
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu li.active-menuitem > a {
    border-left-color: var(--primary-color);
    background-color: var(--root-menu-item-hover-bg);
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu li.active-menuitem > a .layout-submenu-toggler {
    transform: rotate(-180deg);
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu a {
    -webkit-user-select: none;
            user-select: none;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu a.active-menuitem > .layout-submenu-toggler {
    transform: rotate(-180deg);
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu .layout-root-menuitem > div {
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;
    font-size: 12px;
    opacity: 1;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu .layout-root-menuitem > div > .layout-menuitem-text {
    font-size: 0.857rem;
    opacity: 1;
    font-weight: 600;
    text-transform: uppercase;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul {
    width: auto;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul li {
    width: auto;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul a {
    width: auto;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul a span {
    opacity: 1;
    white-space: nowrap;
    transition: all 0.3s;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul {
    overflow: hidden;
    border-radius: var(--border-radius);
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li a {
    padding-left: 3rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li a {
    padding-left: 3.5rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li a {
    padding-left: 4rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li li a {
    padding-left: 5.5rem;
  }
  .layout-container.layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu ul ul li li li li li li a {
    padding-left: 5rem;
  }
  .layout-container.layout-drawer.layout-sidebar-anchored .sidebar-header .layout-sidebar-anchor {
    background-color: var(--primary-color);
  }
  .layout-container.layout-drawer.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 22rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-static .layout-sidebar {
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-static .layout-content-wrapper {
    margin-left: 17rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-static-inactive .layout-sidebar {
    transform: translateX(-100%);
  }
  .layout-container.layout-static-inactive .layout-content-wrapper {
    margin-left: 0;
  }
  .layout-container.layout-overlay .layout-content-wrapper {
    margin-left: 0;
  }
  .layout-container.layout-overlay .layout-sidebar {
    z-index: 999;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
    background: var(--surface-ground);
  }
  .layout-container.layout-overlay.layout-overlay-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-container .content-breadcrumb {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .blocked-scroll {
    overflow: hidden;
  }
  .layout-topbar .topbar-menu {
    margin-right: 0rem !important;
  }
  .layout-topbar .right-panel-button {
    position: absolute !important;
    right: 0;
  }
  .layout-container .layout-content-wrapper {
    margin-left: 0;
    padding: 1rem;
  }
  .layout-container .layout-sidebar {
    z-index: 999;
    transform: translateX(-100%);
    transition: transform var(--transition-duration);
    box-shadow: none;
  }
  .layout-container.layout-mobile-active .layout-sidebar {
    transform: translateX(0);
    background: var(--surface-ground);
  }
  .layout-container.layout-mobile-active .layout-mask {
    display: block;
    animation: fadein var(--transition-duration);
  }
  .layout-container .layout-mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 100%;
    background-color: var(--maskbg);
  }
  .layout-container .topbar-breadcrumb {
    display: none;
  }
  .layout-container .content-breadcrumb {
    display: block;
  }
}
@media screen and (min-width: 1960px) {
  .layout-content,
  .landing-wrapper {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .layout-topbar {
    width: 1504px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .layout-topbar .topbar-menu {
    margin-right: 0rem !important;
  }
  .layout-topbar .right-panel-button {
    position: absolute !important;
    right: 0;
  }
}
.layout-rightmenu-button {
  background: linear-gradient(271.89deg, rgb(70, 82, 104), rgb(115, 130, 161));
  border-radius: 6px 0px 0px 6px;
  border-color: transparent;
  border-left: 0 none;
  box-shadow: 0px 0px 10px rgba(15, 139, 253, 0.25);
  right: 0;
  color: #fff;
}
.layout-rightmenu-button span {
  font-weight: 400 !important;
}
.layout-rightmenu-button:enabled:hover {
  background: linear-gradient(271.89deg, rgba(70, 82, 104, 0.5), rgba(115, 130, 161, 0.5));
  border-color: transparent;
}

.layout-topbar {
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.layout-topbar .topbar-start {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
}
.layout-topbar .topbar-start .topbar-menubutton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 2rem;
  border-radius: var(--border-radius);
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
  transition: background-color var(--transition-duration);
}
.layout-topbar .topbar-start .topbar-menubutton i {
  font-size: 1.25rem;
  color: var(--text-color);
  transition: color var(--transition-duration);
}
.layout-topbar .topbar-start .topbar-menubutton:hover {
  background-color: var(--primary-color);
}
.layout-topbar .topbar-start .topbar-menubutton:hover i {
  color: var(--primary-color-text);
}
.layout-topbar .topbar-menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  padding: 0 1.15rem 0 0.85rem;
  padding-right: 0;
  list-style: none;
  flex-grow: 1;
  color: var(--topbar-item-text-color);
  margin-right: -2rem;
}
.layout-topbar .topbar-menu li {
  margin-left: 1.5rem;
}
.layout-topbar .topbar-menu li.topbar-item {
  margin-left: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.layout-topbar .topbar-menu li.topbar-item img {
  width: 2rem;
  height: 2rem;
}
.layout-topbar .topbar-menu li.topbar-item button {
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  transition: box-shadow var(--transition-duration);
}
.layout-topbar .topbar-menu li.topbar-item button:focus {
  box-shadow: var(--focus-ring);
}
.layout-topbar .topbar-menu li.topbar-item ul {
  position: absolute;
  bottom: -9.4rem;
  right: 0;
  display: none;
  color: var(--text-color);
  background: var(--surface-ground);
  box-shadow: var(--box-shadow);
}
.layout-topbar .topbar-menu li.topbar-item ul.active-topbar-menu {
  display: block;
}
.layout-topbar .topbar-menu li.topbar-item ul a {
  color: var(--text-color);
}
.layout-topbar .topbar-menu li .topbar-search {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.layout-topbar .topbar-menu li .topbar-search .topbar-searchbutton {
  display: flex;
}
.layout-topbar .topbar-menu li .topbar-search .search-input-wrapper {
  position: relative;
  width: 0;
  opacity: 0;
  visibility: hidden;
  transition: 400ms cubic-bezier(0.86, 0, 0.07, 1);
}
.layout-topbar .topbar-menu li .topbar-search .search-input-wrapper span {
  width: 100%;
}
.layout-topbar .topbar-menu li .topbar-search .search-input-wrapper span .p-inputtext {
  width: 100%;
  position: relative;
  border-radius: 40px;
  padding: 9px;
}
.layout-topbar .topbar-menu li .topbar-search .search-input-wrapper span i {
  font-size: 18px;
  margin-top: -9px;
}
.layout-topbar .topbar-menu li .topbar-search.topbar-search-active .topbar-searchbutton {
  opacity: 0;
  display: none;
  pointer-events: none;
  cursor: default;
  transition: opacity 0.1s;
  transition-delay: 0.1s;
}
.layout-topbar .topbar-menu li .topbar-search.topbar-search-active .search-input-wrapper {
  width: 190px;
  opacity: 1;
  visibility: visible;
  border-radius: var(--border-radius);
}
.layout-topbar .topbar-menu li .topbar-search.topbar-search-active .search-input-wrapper i {
  display: block;
}
.layout-topbar .topbar-menu li .topbar-search.topbar-search-active .search-input-wrapper input {
  border-radius: var(--border-radius);
}
.layout-topbar .topbar-menu li button span {
  color: var(--item-text-color);
}

.layout-breadcrumb ol {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 1rem;
  flex-wrap: wrap;
  color: var(--text-color-secondary);
}
.layout-breadcrumb ol li {
  font-weight: 600;
}
.layout-breadcrumb .breadcrumb-menu {
  margin: 0;
  padding: 0 1.15rem 0 0.85rem;
  padding-right: 0;
  list-style: none;
  flex-grow: 1;
  color: var(--topbar-item-text-color);
  margin-right: -2rem;
}
.layout-breadcrumb .breadcrumb-menu li {
  margin-left: 1.5rem;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  margin-left: 0rem;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search .breadcrumb-searchbutton {
  display: flex;
  opacity: 1;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search .search-input-wrapper {
  position: relative;
  width: 0;
  opacity: 0;
  visibility: hidden;
  transition: 400ms cubic-bezier(0.86, 0, 0.07, 1);
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search .search-input-wrapper span {
  width: 100%;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search .search-input-wrapper span .p-inputtext {
  width: 100%;
  position: relative;
  border-radius: 40px;
  padding: 9px;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search .search-input-wrapper span i {
  font-size: 18px;
  margin-top: -9px;
  margin-right: 9px;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search.breadcrumb-search-active .breadcrumb-searchbutton {
  opacity: 0;
  display: none;
  pointer-events: none;
  cursor: default;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search.breadcrumb-search-active .search-input-wrapper {
  width: 100%;
  opacity: 1;
  visibility: visible;
  border-radius: var(--border-radius);
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search.breadcrumb-search-active .search-input-wrapper i {
  display: block;
}
.layout-breadcrumb .breadcrumb-menu li .breadcrumb-search.breadcrumb-search-active .search-input-wrapper .p-input-icon-right input {
  border-radius: var(--border-radius);
  width: 100%;
  background: var(--surface-ground);
}

.content-breadcrumb {
  margin-bottom: 2rem;
  padding: 0 0.5rem;
}

.layout-profile-sidebar.p-sidebar {
  width: 25rem;
}
.layout-profile-sidebar.p-sidebar .p-sidebar-content {
  padding-left: 2rem;
  padding-right: 2rem;
}

.layout-config-button {
  display: block;
  position: fixed;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  background: var(--primary-color);
  color: var(--primary-color-text);
  text-align: center;
  top: 50%;
  right: 0;
  margin-top: -1.5rem;
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: background-color var(--transition-duration);
  overflow: hidden;
  cursor: pointer;
  z-index: 999;
  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);
}
.layout-config-button i {
  font-size: 2rem;
  line-height: inherit;
  transform: rotate(0deg);
  transition: transform 1s;
}
.layout-config-button:hover {
  background: var(--primary-400);
}

.layout-config-sidebar.p-sidebar .p-sidebar-content {
  padding-left: 2rem;
  padding-right: 2rem;
}

.layout-content-wrapper {
  padding: 2rem 2rem 0rem 2rem;
}

h1, h2, h3, h4, h5, h6 {
  margin: 1.5rem 0 1rem 0;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.2;
}
h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {
  margin-top: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

mark {
  background: #FFF8E1;
  padding: 0.25rem 0.4rem;
  border-radius: var(--border-radius);
  font-family: monospace;
}

blockquote {
  margin: 1rem 0;
  padding: 0 2rem;
  border-left: 4px solid #90A4AE;
}

hr {
  border-top: solid var(--surface-border);
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}

p {
  margin: 0 0 1rem 0;
  line-height: 1.5;
}
p:last-child {
  margin-bottom: 0;
}

.card {
  border-radius: 8px;
  background: var(--surface-card);
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 16px;
}
.card .card-header {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card .card-subtitle {
  color: var(--text-color-secondary);
  font-size: 0.857rem;
  font-weight: 500;
  margin: -1rem 0 1rem 0;
}

.p-toast.p-toast-top-right, .p-toast.p-toast-top-left, .p-toast.p-toast-top-center {
  top: 70px;
}

.ng-hidden {
  display: none !important;
}

.background--container-img {
  height: 100vh;
  max-width: 20%;
  border-radius: 1.5rem 0 0 1.5rem;
  position: sticky;
  top: 0;
}

.impersonate-style {
  background-color: var(--primary-color);
  height: 4vh;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1102;
  color: white;
  font-family: var(--font-family);
  font-weight: bolder;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 0 2vw 0 2vw;
}

.clickable {
  cursor: pointer;
  margin-right: 4rem;
}

:host .layout-content > router-outlet + * {
  border: 1px solid red;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media screen and (min-width: 992px) {
  .clickable {
    margin-right: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/layout/styles/layout/_fonts.scss","webpack://./src/app/layout/app.layout.component.scss","webpack://./src/assets/layout/styles/layout/_animation.scss","webpack://./src/assets/layout/styles/layout/_layout_light.scss","webpack://./src/assets/layout/styles/layout/_layout_dark.scss","webpack://./src/assets/layout/styles/layout/_main.scss","webpack://./src/assets/layout/styles/layout/layout.scss","webpack://./src/assets/layout/styles/layout/_sidebar_vertical.scss","webpack://./src/assets/layout/styles/layout/_sidebar_slim.scss","webpack://./src/assets/layout/styles/layout/_sidebar_slim_plus.scss","webpack://./src/assets/layout/styles/layout/_sidebar_horizontal.scss","webpack://./src/assets/layout/styles/layout/_sidebar_reveal.scss","webpack://./src/assets/layout/styles/layout/_sidebar_drawer.scss","webpack://./src/assets/layout/styles/layout/_responsive.scss","webpack://./src/assets/layout/styles/layout/_topbar.scss","webpack://./src/assets/layout/styles/layout/_breadcrumb.scss","webpack://./src/assets/layout/styles/layout/_profile.scss","webpack://./src/assets/layout/styles/layout/_config.scss","webpack://./src/assets/layout/styles/layout/_content.scss","webpack://./src/assets/layout/styles/layout/_typography.scss","webpack://./src/assets/layout/styles/layout/_utils.scss"],"names":[],"mappings":"AAAA,iBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oOAAA;ACCJ;ADKA,uBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mQAAA;ACHJ;ADSA,uBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kQAAA;ACPJ;ADaA,6BAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iSAAA;ACXJ;ADiBA,kBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yOAAA;ACfJ;ADqBA,wBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wQAAA;ACnBJ;ADyBA,oBAAA;AACA;EACI,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mPAAA;ACvBJ;AD6BA,mBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8OAAA;AC3BJ;ADiCA,mBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8OAAA;AC/BJ;ADqCA,yBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6QAAA;ACnCJ;ADyCA,qBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wPAAA;ACvCJ;AD6CA,2BAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uRAAA;AC3CJ;ADiDA,iBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oOAAA;AC/CJ;ADqDA,uBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mQAAA;ACnDJ;ADyDA,kBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yOAAA;ACvDJ;AD6DA,wBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wQAAA;AC3DJ;AChHA;EACI;IACI,6BAAA;EDkHN;EC/GE;IACI,+BAAA;EDiHN;AACF;AC9GA;EACI;IACI,UAAA;IACA,sBAAA;EDgHN;EC7GE;IACI,UAAA;IACA,oBAAA;ED+GN;AACF;AC5GA;EACI;IACI,UAAA;ED8GN;EC3GE;IACI,UAAA;ED6GN;AACF;AC1GA;EACI;IACI,UAAA;ED4GN;ECzGE;IACI,UAAA;ED2GN;AACF;ACxGA;EACI,sDAAA;AD0GJ;;ACvGA;EACI,iCAAA;AD0GJ;;ACvGA;EACI,kCAAA;AD0GJ;;AE1JA;EACI,sCAAA;EACA,uCAAA;EACA,qDAAA;EACA,kBAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;AF6JJ;;AGlKA;EACI,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,4DAAA;EACA,4DAAA;EACA,mDAAA;EACA,gFAAA;AHqKJ;;AIjLA;EACI,sBAAA;AJoLJ;;AIjLA;EACI,YAAA;EACA,eCJG;ALwLP;;AIjLA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,+BAAA;EACA,mCAAA;EACA,kCAAA;AJoLJ;;AIjLA;;EAEI,cAAA;EACA,qBAAA;AJoLJ;;AIjLA;EACI,0BAAA;EACA,iBAAA;AJoLJ;AIlLI;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mCAAA;EACA,4BAAA;EACA,UAAA;AJoLR;AIjLI;EACI,kBAAA;EACA,UAAA;AJmLR;;AI/KA;EACI,wCAAA;EACA,qBAAA;EACA,eAAA;AJkLJ;;AI/KA;EACI,gBAAA;EACA,cAAA;AJkLJ;;AI/KA;EACI,gBAAA;EACA,cAAA;AJkLJ;;AI/KA;EACI,sCAAA;EACA,YAAA;EACA,sCAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;AJkLJ;AIhLI;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;AJkLR;AI1KI;EACI,yBAAA;EACA,qBAAA;AJ4KR;;AIxKA;EACI,uBAAA;EACA,2BAAA;EACA,sCAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;AJ2KJ;AIzKI;EACI,uBAAA;EACA,qBAAA;EACA,cAAA;AJ2KR;AInKI;EACI,uBAAA;EACA,qBAAA;AJqKR;;AIjKA;EACI,6BAAA;EACA,wBAAA;EACA,0BAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;EACA,eAAA;AJoKJ;AIlKI;EACI,cAAA;AJoKR;AI9JA;EACI,oDAAA;AJgKJ;;AI7JA;EACI,uBAAA;AJgKJ;;AI5JA;EACI,UAAA;EACA,gBAAA;AJ+JJ;;AI5JA;EACI,uBAAA;AJ+JJ;;AI5JA;EACI,mBAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;AJ+JJ;;AI5JA,oBAAA;AACA;EACI,mBAAA;EACA,0BAAA;AJ+JJ;;AMhUA;EACI,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;ANmUJ;AMjUI;EACI,eAAA;ANmUR;AMhUI;EACI,sCAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;ANkUR;AMhUQ;EACI,oBAAA;EACA,WAAA;ANkUZ;AMhUY;EACI,eAAA;ANkUhB;AMhUgB;EACI,gBAAA;EACA,cAAA;ANkUpB;AM9TY;EAMI,aAAA;AN2ThB;AMhUgB;EACI,cAAA;EACA,cAAA;ANkUpB;AM1TI;EACI,cAAA;EACA,OAAA;EACA,oBAAA;AN4TR;AMzTI;EACI,SAAA;EACA,iBAAA;EACA,qBAAA;AN2TR;AMzTQ;EACI,sBAAA;AN2TZ;AMzTY;EACI,gBAAA;AN2ThB;AMvTQ;EACI,kBAAA;ANyTZ;AMvTY;EACI,kCAAA;ANyThB;AMpTY;EACI,oBAAA;EACA,qBAAA;EACA,eAAA;ANsThB;AMpTgB;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;ANsTpB;AMlTY;EACI,aAAA;ANoThB;AMhTQ;EACI,yBAAA;UAAA,iBAAA;ANkTZ;AM/SgB;EACI,0BAAA;ANiTpB;AM5SQ;EACI,gDAAA;AN8SZ;AM5SY;EACI,uCAAA;EACA,gDAAA;AN8ShB;AM5SgB;EACI,0BAAA;AN8SpB;AMzSQ;EACI,SAAA;EACA,UAAA;EACA,qBAAA;AN2SZ;AMzSY;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,8FAAA;AN2ShB;AMzSgB;EACI,oBAAA;AN2SpB;AMxSgB;EACI,cAAA;EACA,iBAAA;EACA,gDAAA;AN0SpB;AMvSgB;EACI,uCAAA;EACA,gDAAA;ANySpB;AMtSgB;EACI,gDAAA;ANwSpB;AMpSY;EACI,gBAAA;EACA,mCAAA;ANsShB;AMnSoB;EACI,oBAAA;ANqSxB;AMjSwB;EACI,kBAAA;ANmS5B;AM/R4B;EACI,oBAAA;ANiShC;AM7RgC;EACI,kBAAA;AN+RpC;AM3RoC;EACI,oBAAA;AN6RxC;AMzRwC;EACI,kBAAA;AN2R5C;;AO9cA;EAIgB;IACI,aAAA;EP8clB;EO1cU;IACI,iBAAA;EP4cd;EO3cc;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;EP6clB;EO3ckB;IACI,aAAA;EP6ctB;EO5csB;IACI,gBAAA;EP8c1B;EO1ckB;IACI,eAAA;EP4ctB;EO3csB;IACI,cAAA;EP6c1B;EOvcU;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EPycd;EOxcc;IACI,cAAA;EP0clB;EOxckB;IACI,aAAA;EP0ctB;EOrcU;IACI,qBAAA;EPucd;EOpcU;IACI,eAAA;EPscd;EOpckB;IACI,aAAA;EPsctB;EOnckB;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,uDAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,wBAAA;EPqctB;EOncsB;IACI,aAAA;EPqc1B;EOlcsB;IACI,iBAAA;EPoc1B;EOhcsB;IACI,aAAA;EPkc1B;EO/bsB;IACI,2BAAA;IACA,sCAAA;EPic1B;EO7bkB;IACI,kBAAA;IACA,cAAA;IACA,MAAA;IACA,gBAAA;IACA,iCAAA;IACA,mCAAA;IACA,iCAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;EP+btB;EO7bsB;IACI,qBAAA;IACA,wBAAA;IACA,mCAAA;EP+b1B;EO7b0B;IACI,wBAAA;EP+b9B;EO5b0B;IACI,gDAAA;EP8b9B;EOzb0B;IACI,oBAAA;EP2b9B;EOvb8B;IACI,kBAAA;EPyblC;EOrbkC;IACI,oBAAA;EPubtC;EOnbsC;IACI,kBAAA;EPqb1C;EOjb0C;IACI,oBAAA;EPmb9C;EO/a8C;IACI,kBAAA;EPiblD;AACF;AQlkBA;EAIgB;IACI,aAAA;ERikBlB;EQ7jBU;IACI,uBAAA;IACA,iBAAA;ER+jBd;EQ9jBc;IACI,aAAA;IACA,uBAAA;IACA,mBAAA;ERgkBlB;EQ/jBkB;IACI,aAAA;ERikBtB;EQ9jBkB;IACI,eAAA;IACA,mBAAA;ERgkBtB;EQ3jBU;IACI,WAAA;IACA,iBAAA;IACA,YAAA;ER6jBd;EQ5jBc;IACI,cAAA;ER8jBlB;EQ5jBkB;IACI,aAAA;ER8jBtB;EQzjBU;IACI,iBAAA;ER2jBd;EQxjBU;IACI,eAAA;ER0jBd;EQzjBc;IACI,aAAA;ER2jBlB;EQvjBkB;IACI,cAAA;ERyjBtB;EQpjBkB;IACI,aAAA;ERsjBtB;EQnjBkB;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;IACA,YAAA;IACA,aAAA;IACA,uDAAA;IACA,WAAA;IACA,YAAA;IACA,wBAAA;IACA,YAAA;ERqjBtB;EQnjBsB;IACI,aAAA;ERqjB1B;EQljBsB;IACI,iBAAA;IACA,wBAAA;ERojB1B;EQjjBsB;IACI,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,wBAAA;ERmjB1B;EQ/iBsB;IACI,gDAAA;ERijB1B;EQ7iBkB;IACI,kBAAA;IACA,UAAA;IACA,MAAA;IACA,gBAAA;IACA,iCAAA;IACA,mCAAA;IACA,iCAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;ER+iBtB;EQ7iBsB;IACI,qBAAA;IACA,wBAAA;IACA,mCAAA;ER+iB1B;EQ7iB0B;IACI,wBAAA;ER+iB9B;EQ5iB0B;IACI,gDAAA;ER8iB9B;EQziB0B;IACI,oBAAA;ER2iB9B;EQviB8B;IACI,kBAAA;ERyiBlC;EQriBkC;IACI,oBAAA;ERuiBtC;EQniBsC;IACI,kBAAA;ERqiB1C;EQjiB0C;IACI,oBAAA;ERmiB9C;EQ/hB8C;IACI,kBAAA;ERiiBlD;AACF;AS3rBA;EAIgB;IACI,aAAA;ET0rBlB;ESxrBc;IACI,yBAAA;ET0rBlB;ESxrBc;IACI,aAAA;ET0rBlB;EStrBU;IACI,WAAA;IACA,YAAA;IACA,MAAA;IACA,YAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;ETwrBd;EStrBc;IACI,cAAA;IACA,iBAAA;ETwrBlB;ESvrBkB;IACI,aAAA;ETyrBtB;ESrrBc;IACI,UAAA;ETurBlB;ESrrBsB;IACI,aAAA;ETurB1B;ESprBsB;IACI,eAAA;ETsrB1B;ES/qBU;IACI,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;ETirBd;EShrBc;IACI,mBAAA;ETkrBlB;ESjrBkB;IACI,gBAAA;ETmrBtB;EShrBc;IACI,aAAA;ETkrBlB;ES/qBc;IACI,mCAAA;ETirBlB;ES/qBkB;IACI,aAAA;ETirBtB;ES9qBkB;IACI,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,wBAAA;IACA,uDAAA;ETgrBtB;ES9qBsB;IACI,cAAA;IACA,iBAAA;IACA,0BAAA;ETgrB1B;ES7qBsB;IACI,eAAA;ET+qB1B;ES5qBsB;IACI,mBAAA;IACA,cAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;ET8qB1B;ES3qBsB;IACI,gDAAA;ET6qB1B;ESzqBkB;IACI,kBAAA;IACA,UAAA;IACA,SAAA;IACA,gBAAA;IACA,kCAAA;IACA,iCAAA;IACA,eAAA;IACA,mCAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;ET2qBtB;ESzqBsB;IACI,qBAAA;IACA,wBAAA;IACA,mCAAA;ET2qB1B;ESxqB0B;IACI,gDAAA;ET0qB9B;ESrqB0B;IACI,oBAAA;ETuqB9B;ESnqB8B;IACI,kBAAA;ETqqBlC;ESjqBkC;IACI,oBAAA;ETmqBtC;ES/pBsC;IACI,kBAAA;ETiqB1C;ES7pB0C;IACI,oBAAA;ET+pB9C;ES3pB8C;IACI,kBAAA;ET6pBlD;AACF;AU1zBA;EAIgB;IACI,aAAA;EVyzBlB;EUrzBU;IACI,YAAA;IACA,MAAA;IACA,qDAAA;IACA,+BAAA;IACA,YAAA;IACA,iCAAA;IACA,oBAAA;EVuzBd;EUtzBc;IACI,aAAA;IACA,yBAAA;IACA,mBAAA;IACA,SAAA;IACA,oBAAA;IACA,eAAA;EVwzBlB;EUvzBkB;IACI,iBAAA;EVyzBtB;EUxzBsB;IACI,eAAA;IACA,QAAA;IACA,oBAAA;EV0zB1B;EUtzBsB;IACI,aAAA;EVwzB1B;EUpzBkB;IACI,aAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,sCAAA;IACA,6BAAA;IACA,uEAAA;EVszBtB;EUlzBc;IACI,gBAAA;EVozBlB;EU7yB0B;IACI,kBAAA;EV+yB9B;EU5yB0B;IACI,cAAA;IACA,sBAAA;EV8yB9B;EUzyBkB;IACI,SAAA;IACA,UAAA;IACA,qBAAA;EV2yBtB;EUzyBsB;IACI,oBAAA;EV2yB1B;EU1yB0B;IACI,QAAA;IACA,kBAAA;EV4yB9B;EUzyB0B;IACI,QAAA;IACA,aAAA;IACA,oBAAA;EV2yB9B;EUxyB0B;IACI,QAAA;IACA,eAAA;IACA,eAAA;IACA,WAAA;EV0yB9B;EUlyBc;IACI,oBAAA;IACA,uDAAA;EVoyBlB;EU/xBc;IACI,oBAAA;IACA,wBAAA;EViyBlB;EUhyBkB;IACI,cAAA;EVkyBtB;EUhyBkB;IACI,oBAAA;IACA,8BAAA;EVkyBtB;EUjyBsB;IACI,gBAAA;EVmyB1B;EUlyB0B;IACI,eAAA;EVoyB9B;EUjyB0B;IACI,aAAA;EVmyB9B;EUhyBsB;IACI,cAAA;IACA,iCAAA;EVkyB1B;EUzxB8B;IACI,aAAA;EV2xBlC;EUpxB8B;IACI,cAAA;EVsxBlC;EUnxB0B;IACI,gBAAA;IACA,mCAAA;EVqxB9B;EUlxBkC;IACI,oBAAA;EVoxBtC;EUhxBsC;IACI,kBAAA;EVkxB1C;EU9wB0C;IACI,oBAAA;EVgxB9C;EU5wB8C;IACI,kBAAA;EV8wBlD;EU1wBkD;IACI,oBAAA;EV4wBtD;EUxwBsD;IACI,kBAAA;EV0wB1D;EU1vBkB;IACI,sCAAA;EV4vBtB;EUxvBc;IACI,kBAAA;EV0vBlB;AACF;AWn8BA;EAIgB;IACI,aAAA;EXk8BlB;EW97BU;IACI,YAAA;IACA,MAAA;IACA,iDAAA;IACA,WAAA;IACA,YAAA;IACA,iCAAA;IACA,oBAAA;EXg8Bd;EW/7Bc;IACI,gBAAA;EXi8BlB;EW97Bc;IACI,aAAA;IACA,uBAAA;IACA,SAAA;IACA,oBAAA;IACA,eAAA;EXg8BlB;EW/7BkB;IACI,kBAAA;EXi8BtB;EWh8BsB;IACI,eAAA;IACA,QAAA;EXk8B1B;EW/7BsB;IACI,aAAA;IACA,mBAAA;IACA,QAAA;IACA,iDAAA;IACA,sBAAA;IACA,YAAA;IACA,SAAA;EXi8B1B;EWh8B0B;IACI,QAAA;IACA,iDAAA;IACA,sBAAA;IACA,YAAA;EXk8B9B;EW77BkB;IACI,aAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,sCAAA;IACA,6BAAA;IACA,uEAAA;EX+7BtB;EW37Bc;IACI,gBAAA;EX67BlB;EW17Bc;IACI,oBAAA;IACA,eAAA;EX47BlB;EW17BsB;IACI,UAAA;IACA,mBAAA;IACA,oBAAA;EX47B1B;EW17B0B;IACI,kBAAA;EX47B9B;EWz7B0B;IACI,eAAA;EX27B9B;EWx7B0B;IACI,cAAA;IACA,sBAAA;IACA,kBAAA;EX07B9B;EWr7BkB;IACI,cAAA;IACA,UAAA;IACA,qBAAA;IACA,WAAA;EXu7BtB;EWt7BsB;IACI,YAAA;IACA,WAAA;IACA,oBAAA;EXw7B1B;EWv7B0B;IACI,UAAA;IACA,mBAAA;IACA,oBAAA;EXy7B9B;EWt7B0B;IACI,eAAA;EXw7B9B;EWh7Bc;IACI,oBAAA;IACA,uDAAA;IACA,kBAAA;EXk7BlB;EW76Bc;IACI,YAAA;IACA,oBAAA;EX+6BlB;EW96BkB;IACI,cAAA;EXg7BtB;EW76BkB;IACI,oBAAA;IACA,8BAAA;IACA,eAAA;EX+6BtB;EW96BsB;IACI,gBAAA;EXg7B1B;EW/6B0B;IACI,YAAA;IACA,WAAA;IACA,eAAA;EXi7B9B;EW/6BkC;IACI,WAAA;IACA,eAAA;EXi7BtC;EW/6BkC;IACI,YAAA;IACA,eAAA;EXi7BtC;EW56B0B;IACI,aAAA;EX86B9B;EW16BsB;IACI,cAAA;IACA,iCAAA;EX46B1B;EWx6BkB;IACI,eAAA;EX06BtB;EWx6BsB;IACI,kBAAA;EX06B1B;EWz6B0B;IACI,kCAAA;EX26B9B;EWx6BsB;IACI,gDAAA;EX06B1B;EWz6B0B;IACI,uCAAA;IACA,gDAAA;EX26B9B;EW16B8B;IACI,0BAAA;EX46BlC;EWx6BsB;IACI,yBAAA;YAAA,iBAAA;EX06B1B;EWv6B8B;IACI,0BAAA;EXy6BlC;EWp6B0B;IACI,oBAAA;IACA,qBAAA;IACA,eAAA;IACA,UAAA;EXs6B9B;EWr6B8B;IACI,mBAAA;IACA,UAAA;IACA,gBAAA;IACA,yBAAA;EXu6BlC;EWl6BsB;IACI,WAAA;EXo6B1B;EWn6B0B;IACI,WAAA;EXq6B9B;EWn6B0B;IACI,WAAA;EXq6B9B;EWn6B8B;IACI,cAAA;EXq6BlC;EWl6B8B;IACI,UAAA;IACA,mBAAA;IACA,oBAAA;EXo6BlC;EWj6B0B;IACI,gBAAA;IACA,mCAAA;EXm6B9B;EWh6BkC;IACI,oBAAA;EXk6BtC;EW95BsC;IACI,kBAAA;EXg6B1C;EW55B0C;IACI,oBAAA;EX85B9C;EW15B8C;IACI,kBAAA;EX45BlD;EWx5BkD;IACI,oBAAA;EX05BtD;EWt5BsD;IACI,kBAAA;EXw5B1D;EWx4BkB;IACI,sCAAA;EX04BtB;EWt4Bc;IACI,kBAAA;EXw4BlB;AACF;AY9pCA;EAGY;IACI,qDAAA;EZ8pCd;EY3pCU;IACI,kBAAA;IACA,uDAAA;EZ6pCd;EYxpCU;IACI,4BAAA;EZ0pCd;EYvpCU;IACI,cAAA;EZypCd;EYppCU;IACI,cAAA;EZspCd;EYnpCU;IACI,YAAA;IACA,4BAAA;IACA,qDAAA;IACA,iCAAA;EZqpCd;EYjpCc;IACI,wBAAA;EZmpClB;EY9oCM;IACI,aAAA;EZgpCV;AACF;AY5oCA;EACI;IACI,gBAAA;EZ8oCN;EY1oCM;IACI,6BAAA;EZ4oCV;EYzoCM;IACI,6BAAA;IACA,QAAA;EZ2oCV;EYroCM;IACI,cAAA;IACA,aAAA;EZuoCV;EYpoCM;IACI,YAAA;IACA,4BAAA;IACA,gDAAA;IACA,gBAAA;EZsoCV;EYloCU;IACI,wBAAA;IACA,iCAAA;EZooCd;EYjoCU;IACI,cAAA;IACA,4CAAA;EZmoCd;EY/nCM;IACI,aAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,+BAAA;EZioCV;EY9nCM;IACI,aAAA;EZgoCV;EY7nCM;IACI,cAAA;EZ+nCV;AACF;AYxnCA;EAEI;;IAGI,4BAAA;IACA,6BAAA;EZwnCN;EYrnCE;IACI,aAAA;IACA,4BAAA;IACA,6BAAA;EZunCN;EYrnCM;IACI,6BAAA;EZunCV;EYpnCM;IACI,6BAAA;IACA,QAAA;EZsnCV;AACF;Aa7vCA;EACI,4EAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;EACA,QAAA;EACA,WAAA;Ab+vCJ;Aa9vCI;EACI,2BAAA;AbgwCR;Aa9vCI;EACI,wFAAA;EACA,yBAAA;AbgwCR;;Aa7vCA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AbgwCJ;Aa9vCI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AbgwCR;Aa/vCQ;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,uDAAA;AbiwCZ;Aa/vCY;EACI,kBAAA;EACA,wBAAA;EACA,4CAAA;AbiwChB;Aa9vCY;EACI,sCAAA;AbgwChB;Aa9vCgB;EACI,gCAAA;AbgwCpB;Aa1vCI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;Ab4vCR;Aa1vCQ;EACI,mBAAA;Ab4vCZ;Aa3vCY;EACI,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;Ab6vChB;Aa3vCgB;EACI,WAAA;EACA,YAAA;Ab6vCpB;Aa1vCgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iDAAA;Ab4vCpB;Aa1vCoB;EACI,6BAAA;Ab4vCxB;AaxvCgB;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,aAAA;EACA,wBAAA;EACA,iCAAA;EACA,6BAAA;Ab0vCpB;AazvCoB;EACI,cAAA;Ab2vCxB;AaxvCoB;EACI,wBAAA;Ab0vCxB;AanvCY;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AbqvChB;AapvCgB;EACG,aAAA;AbsvCnB;AanvCgB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,gDAAA;AbqvCpB;AanvCoB;EACI,WAAA;AbqvCxB;AanvCwB;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AbqvC5B;AalvCwB;EACI,eAAA;EACA,gBAAA;AbovC5B;Aa9uCoB;EACI,UAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;AbgvCxB;Aa7uCoB;EACI,YAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;Ab+uCxB;Aa9uCwB;EACI,cAAA;AbgvC5B;Aa9uCwB;EACI,mCAAA;AbgvC5B;AazuCgB;EACI,6BAAA;Ab2uCpB;;Acp5CI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kCAAA;Adu5CR;Acr5CQ;EACI,gBAAA;Adu5CZ;Acp5CI;EACI,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;Ads5CR;Acp5CQ;EACI,mBAAA;Ads5CZ;Acr5CY;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;Adu5ChB;Acr5CgB;EACI,aAAA;EACA,UAAA;Adu5CpB;Acp5CgB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,gDAAA;Ads5CpB;Acp5CoB;EACI,WAAA;Ads5CxB;Acp5CwB;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;Ads5C5B;Acn5CwB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Adq5C5B;Ac/4CoB;EACI,UAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;Adi5CxB;Ac94CoB;EACI,WAAA;EACA,UAAA;EACA,mBAAA;EACA,mCAAA;Adg5CxB;Ac/4CwB;EACI,cAAA;Adi5C5B;Ac94C4B;EACI,mCAAA;EACA,WAAA;EACA,iCAAA;Adg5ChC;;Act4CA;EACI,mBAAA;EACA,iBAAA;Ady4CJ;;Aev+CI;EACI,YAAA;Af0+CR;Aex+CQ;EACI,kBAAA;EACA,mBAAA;Af0+CZ;;AgBh/CA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,4CAAA;EACA,+CAAA;EACA,0BAAA;EACA,6BAAA;EACA,uDAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,+CAAA;AhBm/CJ;AgBj/CI;EACI,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AhBm/CR;AgBh/CI;EACI,8BAAA;AhBk/CR;;AgB5+CQ;EACI,kBAAA;EACA,mBAAA;AhB++CZ;;AiBrhDA;EACI,4BAAA;AjBwhDJ;;AkBzhDA;EACI,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AlB4hDJ;AkB1hDI;EACI,aAAA;AlB4hDR;;AkBxhDA;EACI,iBAAA;AlB2hDJ;;AkBxhDA;EACI,eAAA;AlB2hDJ;;AkBxhDA;EACI,kBAAA;AlB2hDJ;;AkBxhDA;EACI,iBAAA;AlB2hDJ;;AkBxhDA;EACI,kBAAA;AlB2hDJ;;AkBxhDA;EACI,eAAA;AlB2hDJ;;AkBxhDA;EACI,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,sBAAA;AlB2hDJ;;AkBxhDA;EACI,cAAA;EACA,eAAA;EACA,8BAAA;AlB2hDJ;;AkBxhDA;EACI,uCAAA;EACA,uBAAA;EACA,cAAA;AlB2hDJ;;AkBxhDA;EACI,kBAAA;EACA,gBAAA;AlB2hDJ;AkBzhDI;EACI,gBAAA;AlB2hDR;;AmBtlDA;EACI,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AnBylDJ;AmBvlDI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AnBylDR;AmBtlDI;EACI,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AnBwlDR;;AmBnlDI;EAGI,SAAA;AnBolDR;;AmBhlDA;EACI,wBAAA;AnBmlDJ;;AAhnDA;EACI,aAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;AAmnDJ;;AAhnDA;EACI,sCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAmnDJ;;AAhnDA;EACI,eAAA;EACA,kBAAA;AAmnDJ;;AAhnDA;EACI,qBAAA;AAmnDJ;;AAhnDA;EACI;IACI,uBAAA;EAmnDN;EAhnDE;IACI,yBAAA;EAknDN;AACF;AA/mDA;EACI;IACI,kBAAA;EAinDN;AACF","sourcesContent":["/* poppins-thin */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 100;\n    src: local('Poppins Thin'), local('Poppins-Thin'),\n        url('../../fonts/Poppins-Thin.woff2') format('woff2'),\n        url('../../fonts/Poppins-Thin.woff') format('woff'),\n        url('../../fonts/Poppins-Thin.ttf') format('truetype');\n}\n\n/* poppins-thinItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 100;\n    src: local('Poppins Thin Italic'), local('Poppins-ThinItalic'),\n        url('../../fonts/Poppins-ThinItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-ThinItalic.woff') format('woff'),\n        url('../../fonts/Poppins-ThinItalic.ttf') format('truetype');\n}\n\n/* poppins-extraLight */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 200;\n    src: local('Poppins ExtraLight'), local('Poppins-ExtraLight'),\n        url('../../fonts/Poppins-ExtraLight.woff2') format('woff2'),\n        url('../../fonts/Poppins-ExtraLight.woff') format('woff'),\n        url('../../fonts/Poppins-ExtraLight.ttf') format('truetype');\n}\n\n/* poppins-extraLightItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 200;\n    src: local('Poppins ExtraLight Italic'), local('Poppins-ExtraLightItalic'),\n        url('../../fonts/Poppins-ExtraLightItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-ExtraLightItalic.woff') format('woff'),\n        url('../../fonts/Poppins-ExtraLightItalic.ttf') format('truetype');\n}\n\n/* poppins-light */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 300;\n    src: local('Poppins Light'), local('Poppins-Light'),\n        url('../../fonts/Poppins-Light.woff2') format('woff2'),\n        url('../../fonts/Poppins-Light.woff') format('woff'),\n        url('../../fonts/Poppins-Light.ttf') format('truetype');\n}\n\n/* poppins-lightItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 300;\n    src: local('Poppins Light Italic'), local('Poppins-LightItalic'),\n        url('../../fonts/Poppins-LightItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-LightItalic.woff') format('woff'),\n        url('../../fonts/Poppins-LightItalic.ttf') format('truetype');\n}\n\n/* poppins-regular */\n@font-face {\n    font-family: 'Poppins';\n    line-height: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    src: local('Poppins Regular'), local('Poppins-Regular'),\n        url('../../fonts/Poppins-Regular.woff2') format('woff2'),\n        url('../../fonts/Poppins-Regular.woff') format('woff'),\n        url('../../fonts/Poppins-Regular.ttf') format('truetype');\n}\n\n/* poppins-italic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 400;\n    src: local('Poppins Italic'), local('Poppins-Italic'),\n        url('../../fonts/Poppins-Italic.woff2') format('woff2'),\n        url('../../fonts/Poppins-Italic.woff') format('woff'),\n        url('../../fonts/Poppins-Italic.ttf') format('truetype');\n}\n\n/* poppins-medium */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 500;\n    src: local('Poppins Medium'), local('Poppins-Medium'),\n        url('../../fonts/Poppins-Medium.woff2') format('woff2'),\n        url('../../fonts/Poppins-Medium.woff') format('woff'),\n        url('../../fonts/Poppins-Medium.ttf') format('truetype');\n}\n\n/* poppins-mediumItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 500;\n    src: local('Poppins Medium Italic'), local('Poppins-MediumItalic'),\n        url('../../fonts/Poppins-MediumItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-MediumItalic.woff') format('woff'),\n        url('../../fonts/Poppins-MediumItalic.ttf') format('truetype');\n}\n\n/* poppins-semiBold */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    src: local('Poppins SemiBold'), local('Poppins-SemiBold'),\n        url('../../fonts/Poppins-SemiBold.woff2') format('woff2'),\n        url('../../fonts/Poppins-SemiBold.woff') format('woff'),\n        url('../../fonts/Poppins-SemiBold.ttf') format('truetype');\n}\n\n/* poppins-semiBoldItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 600;\n    src: local('Poppins SemiBold Italic'), local('Poppins-SemiBoldItalic'),\n        url('../../fonts/Poppins-SemiBoldItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-SemiBoldItalic.woff') format('woff'),\n        url('../../fonts/Poppins-SemiBoldItalic.ttf') format('truetype');\n}\n\n/* poppins-bold */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 700;\n    src: local('Poppins Bold'), local('Poppins-Bold'),\n        url('../../fonts/Poppins-Bold.woff2') format('woff2'),\n        url('../../fonts/Poppins-Bold.woff') format('woff'),\n        url('../../fonts/Poppins-Bold.ttf') format('truetype');\n}\n\n/* poppins-boldItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 700;\n    src: local('Poppins Bold Italic'), local('Poppins-BoldItalic'),\n        url('../../fonts/Poppins-BoldItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-BoldItalic.woff') format('woff'),\n        url('../../fonts/Poppins-BoldItalic.ttf') format('truetype');\n}\n\n/* poppins-black */\n@font-face {\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 900;\n    src: local('Poppins Black'), local('Poppins-Black'),\n        url('../../fonts/Poppins-Black.woff2') format('woff2'),\n        url('../../fonts/Poppins-Black.woff') format('woff'),\n        url('../../fonts/Poppins-Black.ttf') format('truetype');\n}\n\n/* poppins-blackItalic */\n@font-face {\n    font-family: 'Poppins';\n    font-style: italic;\n    font-weight: 900;\n    src: local('Poppins Black Italic'), local('Poppins-BlackItalic'),\n        url('../../fonts/Poppins-BlackItalic.woff2') format('woff2'),\n        url('../../fonts/Poppins-BlackItalic.woff') format('woff'),\n        url('../../fonts/Poppins-BlackItalic.ttf') format('truetype');\n}\n","@import \"src/assets/layout/styles/layout/layout.scss\";\n\n.background--container-img {\n    height: 100vh;\n    max-width: 20%;\n    border-radius: 1.5rem 0 0 1.5rem;\n    position: sticky;\n    top: 0;\n}\n\n.impersonate-style {\n    background-color: var(--primary-color);\n    height: 4vh;\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    z-index: 1102;\n    color: white;\n    font-family: var(--font-family);\n    font-weight: bolder;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    padding: 0 2vw 0 2vw;\n}\n\n.clickable {\n    cursor: pointer;\n    margin-right: 4rem;\n}\n\n:host .layout-content > router-outlet + * {\n    border: 1px solid red;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@media screen and (min-width: ($breakpoint)) {\n    .clickable {\n        margin-right: 3rem;\n    }\n}","@keyframes px-mask-in {\n    from {\n        background-color: transparent;\n    }\n\n    to {\n        background-color: var(--maskbg);\n    }\n}\n\n@keyframes px-scalein {\n    0% {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    100% {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n}\n\n@keyframes px-fadein {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes px-fadeout {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.px-scalein {\n    animation: px-scalein .12s cubic-bezier(0, 0, 0.2, 1);\n}\n\n.px-fadein {\n    animation: px-fadein .15s linear;\n}\n\n.px-fadeout {\n    animation: px-fadeout .15s linear;\n}","$breakpoint: 992px !default;\n$scale: 14px !default;\n\n.layout-light {\n    --sidebar-shadow: 0px 4px 50px #D9DDFC;\n    --sidebar-border: 1px solid transparent;\n    --card-shadow: 0px 4px 30px rgba(221, 224, 255, 0.54);\n    --body-bg: #F2F2F2; // linear-gradient(180deg, #F6F9FC 0%, #ECECF9 100%) \n    --body-image: url(\"/assets/layout/images/effect-onlight.png\");\n    --root-menu-item-hover-bg: rgba(68, 72, 109, 0.07);\n    --exception-pages-image: url('/assets/layout/images/pages/exception-onlight.png');\n}","\n\n$breakpoint:992px !default;\n$scale:14px !default;\n\n.layout-dark {\n    --sidebar-shadow: none;\n    --sidebar-border: 1px solid var(--surface-border);\n    --card-shadow: none;\n    --body-bg:linear-gradient(180deg, #2E323F 0%, #0A061A 100%) ;\n    --body-image:  url(\"/assets/layout/images/effect-ondark.png\");\n    --root-menu-item-hover-bg:rgba(255, 255, 255, 0.05);\n    --exception-pages-image: url('/assets/layout/images/pages/exception-ondark.png');\n}\n\n\n","* {\n    box-sizing: border-box;\n}\n\nhtml {\n    height: 100%;\n    font-size: $scale;\n}\n\nbody {\n    font-weight: 400;\n    padding: 0;\n    margin: 0;\n    min-height: 100%;\n    color: var(--text-color);\n    font-family: var(--font-family);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na,\na:visited {\n    color: inherit;\n    text-decoration: none;\n}\n\n.layout-container {\n    background: var(--body-bg);\n    min-height: 100vh;\n\n    &:before {\n        min-height: 100vh;\n        height: 100%;\n        width: 100%;\n        content: \"\";\n        z-index: 0;\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-image: var(--body-image);\n        background-repeat: no-repeat;\n        z-index: 0;\n    }\n\n    .layout-content-wrapper {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n.DC--card {\n    background-color: var(--surface-section);\n    border-radius: 0.8rem;\n    padding: 0.5rem;\n}\n\n.DC--title {\n    font-weight: 900;\n    color: #545c64;\n}\n\n.DC--title2 {\n    font-weight: 600;\n    color: #545c64;\n}\n\n.dc--btn-primary {\n    background-color: var(--primary-color);\n    color: white;\n    border: 1px solid var(--primary-color);\n    transition: background-color 0.3s, color 0.3s;\n    border-radius: 6px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #d61058;\n        border-color: #d61058;\n        color: white;\n    }\n\n    // &:focus {\n    //     outline: none;\n    //     box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);\n    // }\n\n    &:active {\n        background-color: #af003d;\n        border-color: #af003d;\n    }\n}\n\n.dc--btn-secondary {\n    background-color: white;\n    color: var(--primary-color);\n    border: 1px solid var(--primary-color);\n    transition: background-color 0.3s, color 0.3s;\n    border-radius: 6px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: white;\n        border-color: #d61058;\n        color: #d61058;\n    }\n\n    // &:focus {\n    //     outline: none;\n    //     box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);\n    // }\n\n    &:active {\n        background-color: white;\n        border-color: #af003d;\n    }\n}\n\n.dc--btn-tertiary {\n    background-color: transparent;\n    color: var(--text-color);\n    font-size: 1rem !important;\n    font-weight: 600;\n    border: 0 solid transparent;\n    transition: background-color 0.3s, color 0.3s;\n    cursor: pointer;\n\n    &:hover {\n        color: #6a737c;\n    }\n\n    &:active {}\n}\n\n.p-scrollpanel .p-scrollpanel-bar {\n    background-color: rgba(68, 72, 109, 0.15) !important;\n}\n\n.p-treetable .p-treetable-tfoot > tr > td {\n    border: none !important;\n}\n\n\n::-webkit-scrollbar {\n    width: 6px;\n    margin-left: 3px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #dadada;\n    /* Color of the scrollbar handle */\n    border-radius: 5px;\n    /* Rounded corners */\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n    background: #c0bebe;\n    /* Change color on hover */\n}","\n$breakpoint:992px !default;\n$scale:14px !default;\n\n@import './_fonts';\n@import './_animation';\n@import './_layout_light';\n@import './layout_dark';\n@import './_main';\n@import './_sidebar_vertical';\n@import './_sidebar_slim';\n@import './_sidebar_slim_plus';\n@import './_sidebar_horizontal';\n@import './_sidebar_reveal';\n@import './_sidebar_drawer';\n@import './_responsive';\n@import './_topbar';\n@import './_breadcrumb';\n@import './_profile';\n@import './_config';\n@import './_content';\n@import './_typography';\n@import './_utils';\n",".layout-sidebar {\n    position: fixed;\n    height: 100%;\n    top: 0;\n    left: 0;\n    width: 16rem;\n    display: flex;\n    flex-direction: column;\n    border-radius: 0px 40px 40px 0px;\n\n    .material-symbols-outlined {\n        font-size: 20px;\n    }\n\n    .sidebar-header {\n        padding: 1.7rem 1.57rem .5rem 2.42rem;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n\n        .app-logo {\n            margin-left: -0.6rem;\n            width: 100%;\n\n            .app-logo-normal {\n                display: inline;\n\n                img {\n                    height: 1.714rem;\n                    border: 0 none;\n                }\n            }\n\n            .app-logo-small {\n                img {\n                    height: 2.5rem;\n                    border: 0 none;\n                }\n\n                display: none;\n            }\n        }\n    }\n\n    .layout-menu-container {\n        overflow: auto;\n        flex: 1;\n        padding-bottom: 2rem;\n    }\n\n    .layout-menu {\n        margin: 0;\n        padding: 0 1.5rem;\n        list-style-type: none;\n\n        > li {\n            margin-bottom: 2.25rem;\n\n            &:first-child {\n                margin-top: 2rem;\n            }\n        }\n\n        li {\n            border-radius: 8px;\n\n            a {\n                border-left: 8px solid transparent;\n            }\n        }\n\n        .layout-root-menuitem {\n            > div {\n                padding-left: 1.5rem;\n                margin-bottom: 0.5rem;\n                font-size: 12px;\n\n                > .layout-menuitem-text {\n                    font-size: 0.857rem;\n                    font-weight: 600;\n                    text-transform: uppercase;\n                }\n            }\n\n            > a {\n                display: none;\n            }\n        }\n\n        a {\n            user-select: none;\n\n            &.active-menuitem {\n                > .layout-submenu-toggler {\n                    transform: rotate(-180deg);\n                }\n            }\n        }\n\n        li.active-menuitem {\n            background-color: var(--root-menu-item-hover-bg);\n\n            > a {\n                border-left-color: var(--primary-color);\n                background-color: var(--root-menu-item-hover-bg);\n\n                .layout-submenu-toggler {\n                    transform: rotate(-180deg);\n                }\n            }\n        }\n\n        ul {\n            margin: 0;\n            padding: 0;\n            list-style-type: none;\n\n            a {\n                display: flex;\n                align-items: center;\n                position: relative;\n                outline: 0 none;\n                color: var(--text-color);\n                cursor: pointer;\n                padding: 0.5rem 1rem;\n                border-radius: 8px;\n                transition: background-color var(--transition-duration), box-shadow var(--transition-duration);\n\n                .layout-menuitem-icon {\n                    margin-right: 0.5rem;\n                }\n\n                .layout-submenu-toggler {\n                    font-size: 75%;\n                    margin-left: auto;\n                    transition: transform var(--transition-duration);\n                }\n\n                &.active-route {\n                    border-left-color: var(--primary-color);\n                    background-color: var(--root-menu-item-hover-bg);\n                }\n\n                &:hover {\n                    background-color: var(--root-menu-item-hover-bg);\n                }\n            }\n\n            ul {\n                overflow: hidden;\n                border-radius: var(--border-radius);\n\n                li {\n                    a {\n                        padding-left: 2.5rem;\n                    }\n\n                    li {\n                        a {\n                            padding-left: 3rem;\n                        }\n\n                        li {\n                            a {\n                                padding-left: 3.5rem;\n                            }\n\n                            li {\n                                a {\n                                    padding-left: 4rem;\n                                }\n\n                                li {\n                                    a {\n                                        padding-left: 5.5rem;\n                                    }\n\n                                    li {\n                                        a {\n                                            padding-left: 5rem;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-slim {\n            .layout-topbar {\n                .topbar-menubutton {\n                    display: none;\n                }\n            }\n\n            .sidebar-header {\n                padding:  1.7rem 0;\n                .app-logo {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n\n                    .app-logo-normal {\n                        display: none;\n                        img {\n                            height: 1.714rem;\n                        }\n                    }\n\n                    .app-logo-small {\n                        display: inline;\n                        img {\n                            height: 2.5rem;\n                        }\n                    }\n                }\n            }\n\n            .layout-sidebar {\n                width: 5.857rem;\n                overflow: visible;\n                z-index: 999;\n                .layout-menu-container {\n                    overflow: auto;\n\n                    &::-webkit-scrollbar {\n                        display: none;\n                    }\n                }\n            }\n\n            .layout-content-wrapper {\n                margin-left: 5.857rem;\n            }\n\n            .layout-menu {\n                padding: 0 1rem;\n                .layout-root-menuitem {\n                    > .layout-menuitem-root-text {\n                        display: none;\n                    }\n\n                    > a {\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        border-radius: 12px;\n                        border: none;\n                        cursor: pointer;\n                        outline: none;\n                        transition: background-color var(--transition-duration);\n                        margin: 0px;\n                        padding: 8px;\n                        width: 40px;\n                        height: 40px;\n                        margin: 0 auto 1rem auto;\n\n                        .layout-submenu-toggler {\n                            display: none;\n                        }\n\n                        .layout-menuitem-icon {\n                            font-size: 1.5rem;\n                          \n                        }\n\n                        .layout-menuitem-text {\n                            display: none;\n                        }\n\n                        &:hover {\n                            color: (--primary-color-text);\n                            background-color: var(--primary-color);\n                        }\n                    }\n\n                    > ul {\n                        position: absolute;\n                        left: 5.857rem;\n                        top: 0;\n                        min-width: 15rem;\n                        background: var(--surface-ground);\n                        border-radius: var(--border-radius);\n                        box-shadow: var(--sidebar-shadow);\n                        padding: 0.5rem;\n                        max-height: 20rem;\n                        overflow: auto;\n                        z-index: 999;\n\n                        a {\n                            padding-right: 0.5rem;\n                            color: var(--text-color);\n                            border-radius: var(--border-radius);\n\n                            .layout-menuitem-icon {\n                                color: var(--text-color);\n                            }\n\n                            &:hover {\n                                background-color: var(--root-menu-item-hover-bg);\n                            }\n                        }\n\n                        li {\n                            a {\n                                padding-left: 0.5rem;\n                            }\n\n                            li {\n                                a {\n                                    padding-left: 1rem;\n                                }\n\n                                li {\n                                    a {\n                                        padding-left: 1.5rem;\n                                    }\n\n                                    li {\n                                        a {\n                                            padding-left: 2rem;\n                                        }\n\n                                        li {\n                                            a {\n                                                padding-left: 2.5rem;\n                                            }\n\n                                            li {\n                                                a {\n                                                    padding-left: 3rem;\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-slim-plus {\n            .layout-topbar {\n                .topbar-menubutton {\n                    display: none;\n                }\n            }\n\n            .sidebar-header {\n                justify-content: center;\n                padding:  1.7rem 0;\n                .app-logo {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    .app-logo-normal {\n                        display: none;\n                    }\n            \n                    .app-logo-small {\n                        display: inline;\n                        align-items: center;\n                    }\n                }    \n            }\n           \n            .layout-sidebar {\n                width: 8rem;\n                overflow: visible;\n                z-index: 999;\n                .layout-menu-container {\n                    overflow: auto;\n\n                    &::-webkit-scrollbar {\n                        display: none;\n                    }\n                }\n            }\n\n            .layout-content-wrapper {\n                margin-left: 8rem;\n            }\n\n            .layout-menu {\n                padding: 0 1rem;\n                ul {\n                    display: none;\n                }\n                \n                li.active-menuitem {\n                    > ul {\n                        display: block;\n                    }\n                }\n\n                .layout-root-menuitem {\n                    > .layout-menuitem-root-text {\n                        display: none;\n                    }\n\n                    > a {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        justify-content: center;\n                        border-radius: 12px;\n                        text-align: center;\n                        cursor: pointer;\n                        border: none;\n                        outline: none;\n                        transition: background-color var(--transition-duration);\n                        width: auto;\n                        height: auto;\n                        margin: 0 auto 1rem auto;\n                        padding: 8px;\n\n                        .layout-submenu-toggler {\n                            display: none;\n                        }\n\n                        .layout-menuitem-icon {\n                            font-size: 1.5rem;\n                            color: var(--text-color);\n                        }\n\n                        .layout-menuitem-text {\n                            font-size: 0.875rem;\n                            display: block;\n                            margin-top: 0.25rem;\n                            color: var(--text-color);\n                        }\n\n\n                        &:hover {\n                            background-color: var(--root-menu-item-hover-bg);\n                        }\n                    }\n\n                    > ul {\n                        position: absolute;\n                        left: 8rem;\n                        top: 0;\n                        min-width: 15rem;\n                        background: var(--surface-ground);\n                        border-radius: var(--border-radius);\n                        box-shadow: var(--sidebar-shadow);\n                        padding: 0.5rem;\n                        max-height: 20rem;\n                        overflow: auto;\n                        z-index: 999;\n\n                        a {\n                            padding-right: 0.5rem;\n                            color: var(--text-color);\n                            border-radius: var(--border-radius);\n\n                            .layout-menuitem-icon {\n                                color: var(--text-color);\n                            }\n\n                            &:hover {\n                                background-color: var(--root-menu-item-hover-bg);\n                            }\n                        }\n\n                        li {\n                            a {\n                                padding-left: 0.5rem;\n                            }\n            \n                            li {\n                                a {\n                                    padding-left: 1rem;\n                                }\n            \n                                li {\n                                    a {\n                                        padding-left: 1.5rem;\n                                    }\n            \n                                    li {\n                                        a {\n                                            padding-left: 2rem;\n                                        }\n            \n                                        li {\n                                            a {\n                                                padding-left: 2.5rem;\n                                            }\n            \n                                            li {\n                                                a {\n                                                    padding-left: 3rem;\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-horizontal {\n            .layout-topbar {\n                .topbar-menubutton {\n                    display: none;\n                }\n                .layout-topbar-menu-section{\n                    width: calc(100% - 320px);\n                }\n                .topbar-breadcrumb{\n                    display: none;\n                }\n            }\n           \n            .layout-sidebar {\n                width: auto;\n                height: auto;\n                top: 0;\n                z-index: 999;\n                overflow: visible;\n                flex-direction: row;\n                position: static;\n\n                .layout-menu-container {\n                    overflow: auto;\n                    padding-bottom: 0;\n                    &::-webkit-scrollbar {\n                        display: none;\n                    }\n                }\n\n                .sidebar-header{\n                    padding: 0;\n                    .app-logo {\n                        .app-logo-normal {\n                            display: none;\n                        }\n                \n                        .app-logo-small {\n                            display: inline;\n                        }\n                    }\n                }\n    \n            }\n\n            .layout-menu {\n                display: flex;\n                flex-wrap: nowrap;\n                flex-direction: row;\n                align-items: center;\n                height: 100%;\n                padding: 0 1rem;\n                > li { \n                    margin-bottom: 0rem;\n                    &:first-child {\n                        margin-top: 0rem;\n                    }\n                }\n                ul {\n                    display: none;\n                }\n\n                .layout-root-menuitem {\n                    border-radius: var(--border-radius);\n\n                    > .layout-menuitem-root-text {\n                        display: none;\n                    }\n\n                    > a {\n                        display: flex;\n                        align-items: center;\n                        padding: .75rem;\n                        border-radius: 6px;\n                        border: none;\n                        cursor: pointer;\n                        outline: none;\n                        color: var(--text-color);\n                        transition: background-color var(--transition-duration);\n\n                        .layout-submenu-toggler {\n                            display: block;\n                            margin-left: auto;\n                            transition: transform 0.2s;\n                        }\n\n                        .layout-menuitem-icon {\n                            font-size: 1rem;\n                        }\n\n                        .layout-menuitem-text {\n                            font-size: 0.875rem;\n                            display: block;\n                            margin-left: .75rem;\n                            margin-right: .75rem;\n                            white-space: nowrap;\n                        }\n\n                        &:hover {\n                            background-color: var(--menuitem-hover-bg-color);\n                        }\n                    }\n\n                    > ul {\n                        position: absolute;\n                        left: auto;\n                        top: 5rem;\n                        min-width: 15rem;\n                        background: var(--surface-overlay);\n                        box-shadow: var(--sidebar-shadow);\n                        padding: .8rem;\n                        border-radius: var(--border-radius);\n                        max-height: 20rem;\n                        overflow: auto;\n                        z-index: 999;\n\n                        a {\n                            padding-right: .5rem;\n                            color: var(--text-color);\n                            border-radius: var(--border-radius);\n\n\n                            &:hover {\n                                background-color: var(--root-menu-item-hover-bg);\n                            }\n                        }\n\n                        li {\n                            a {\n                                padding-left: 0.5rem;\n                            }\n            \n                            li {\n                                a {\n                                    padding-left: 1rem;\n                                }\n            \n                                li {\n                                    a {\n                                        padding-left: 1.5rem;\n                                    }\n            \n                                    li {\n                                        a {\n                                            padding-left: 2rem;\n                                        }\n            \n                                        li {\n                                            a {\n                                                padding-left: 2.5rem;\n                                            }\n            \n                                            li {\n                                                a {\n                                                    padding-left: 3rem;\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-reveal {\n            .layout-topbar {\n                .topbar-menubutton {\n                    display: none;\n                }\n            }\n\n            .layout-sidebar {\n                height: 100%;\n                top: 0;\n                transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);\n                transform: translateX(-15.5rem);\n                z-index: 999;\n                background: var(--surface-ground);\n                padding-bottom: 3rem;\n                .sidebar-header {\n                    display: flex;\n                    justify-content: flex-end;\n                    align-items: center;\n                    gap: 1rem;\n                    padding: 1.5rem 1rem;\n                    height: 5.71rem;\n                    .app-logo {\n                        text-align: right;\n                        .app-logo-small {\n                            display: inline;\n                            order: 1;\n                            margin-right: .5rem;\n               \n                        }\n\n                        .app-logo-normal {\n                            display: none;\n                        }\n                    }\n\n                    .layout-sidebar-anchor {\n                        display: none;\n                        width: 1.25rem;\n                        height: 1.25rem;\n                        border-radius: 50%;\n                        border: 2px solid var(--primary-color);\n                        background-color: transparent;\n                        transition: background-color var(--transition-duration),\n                            transform 0.3s;\n                    }\n                }\n                .layout-menu-container {\n                    overflow: hidden;\n                }\n\n\n                .layout-menu {\n                    .layout-root-menuitem {\n                        >.layout-menuitem-root-text {\n                            >span {\n                                margin-right: auto;\n                            }\n\n                            >.layout-menuitem-root-icon {\n                                display: block;\n                                margin-right: 0.125rem;\n                            }\n                        }\n                    }\n\n                    ul {\n                        margin: 0;\n                        padding: 0;\n                        list-style-type: none;\n\n                        a {\n                            padding: 0.5rem 1rem;\n                            .layout-menuitem-text {\n                                order: 1;\n                                margin-right: auto;\n                            }\n\n                            .layout-submenu-toggler {\n                                order: 2;\n                                display: none;\n                                margin-right: 0.5rem;\n                            }\n\n                            .layout-menuitem-icon {\n                                order: 3;\n                                margin-right: 0;\n                                font-size: 1rem;\n                                width: auto;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.layout-reveal {\n                .layout-content-wrapper {\n                    margin-left: 4.25rem;\n                    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);\n                }\n            }\n\n            &.layout-sidebar-active {\n                .layout-sidebar {\n                    padding-bottom: 0rem;\n                    transform: translateX(0);\n                    .layout-menu-container {\n                        overflow: auto;\n                    }\n                    .sidebar-header {\n                        padding: 1.5rem 2rem;\n                        justify-content: space-between;\n                        .app-logo {\n                            text-align: left;\n                            .app-logo-normal {\n                                display: inline;\n                            }\n                    \n                            .app-logo-small {\n                                display: none;\n                            }\n                        }\n                        .layout-sidebar-anchor {\n                            display: block;\n                            animation: px-fadein 0.15s linear;\n                        }\n                    }\n\n                 \n\n                    .layout-menu {\n                        .layout-root-menuitem {\n                            >.layout-menuitem-root-text {\n                                >.layout-menuitem-root-icon {\n                                    display: none;\n                                }\n                            }\n                        }\n\n                        ul {\n                            a {\n                                .layout-submenu-toggler {\n                                    display: block;\n                                }\n                            }\n                            ul {\n                                overflow: hidden;\n                                border-radius: var(--border-radius);\n                \n                                li {\n                                    a {\n                                        padding-left: 2.5rem;\n                                    }\n                \n                                    li {\n                                        a {\n                                            padding-left: 3rem;\n                                        }\n                \n                                        li {\n                                            a {\n                                                padding-left: 3.5rem;\n                                            }\n                \n                                            li {\n                                                a {\n                                                    padding-left: 4rem;\n                                                }\n                \n                                                li {\n                                                    a {\n                                                        padding-left: 5.5rem;\n                                                    }\n                \n                                                    li {\n                                                        a {\n                                                            padding-left: 5rem;\n                                                        }\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.layout-sidebar-anchored {\n                .sidebar-header {\n                    .layout-sidebar-anchor {\n                        background-color: var(--primary-color);\n                    }\n                }\n\n                .layout-content-wrapper {\n                    margin-left: 22rem;\n                }\n            }\n        }\n    }\n}","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-drawer {\n            .layout-topbar {\n                .topbar-menubutton {\n                    display: none;\n                }\n            }\n\n            .layout-sidebar {\n                height: 100%;\n                top: 0;\n                transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);\n                width: 6rem;\n                z-index: 999;\n                background: var(--surface-ground);\n                padding-bottom: 3rem;\n                .layout-menu-container {\n                    overflow: hidden;\n                }\n\n                .sidebar-header {\n                    display: flex;\n                    justify-content: center;\n                    gap: 1rem;\n                    padding: 1.5rem 0rem;\n                    height: 5.71rem;\n                    .app-logo {\n                        text-align: center;\n                        .app-logo-small {\n                            display: inline;\n                            order: 1;\n                        }\n\n                        .app-logo-normal {\n                            display: flex;\n                            align-items: center;\n                            width: 0;\n                            transition: width 0.1s cubic-bezier(0, 0, 0.2, 1);\n                            transition-delay: 50ms;\n                            max-width: 0;\n                            height: 0;\n                            img {\n                                width: 0;\n                                transition: width 0.1s cubic-bezier(0, 0, 0.2, 1);\n                                transition-delay: 50ms;\n                                max-width: 0;\n                            }\n                        }\n                    }\n\n                    .layout-sidebar-anchor {\n                        display: none;\n                        width: 1.25rem;\n                        height: 1.25rem;\n                        border-radius: 50%;\n                        border: 2px solid var(--primary-color);\n                        background-color: transparent;\n                        transition: background-color var(--transition-duration), transform 0.3s;\n                    }\n                }\n\n                .layout-menu-container {\n                    overflow: hidden;\n                }\n\n                .layout-menu {\n                    transition: all 0.4s;\n                    padding: 0 1rem;\n                    .layout-root-menuitem {\n                        > .layout-menuitem-root-text {\n                            opacity: 0;\n                            white-space: nowrap;\n                            transition: all 0.1s;\n\n                            > span {\n                                margin-right: auto;\n                            }\n\n                            .layout-menuitem-icon {\n                                font-size: 1rem;\n                            }\n\n                            > .layout-menuitem-root-icon {\n                                display: block;\n                                margin-right: 0.125rem;\n                                font-size: 1.25rem;\n                            }\n                        }\n                    }\n\n                    ul {\n                        margin: 0 auto;\n                        padding: 0;\n                        list-style-type: none;\n                        width: 3rem;\n                        a {\n                            border: none;\n                            width: 3rem;\n                            padding: 0.5rem 1rem;\n                            span {\n                                opacity: 0;\n                                white-space: nowrap;\n                                transition: all 0.1s;\n                            }\n\n                            .layout-menuitem-icon {\n                                font-size: 1rem;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.layout-drawer {\n                .layout-content-wrapper {\n                    margin-left: 5.25rem;\n                    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);\n                    overflow-x: hidden;\n                }\n            }\n\n            &.layout-sidebar-active {\n                .layout-sidebar {\n                    width: 22rem;\n                    padding-bottom: 0rem;\n                    .layout-menu-container {\n                        overflow: auto;\n                    }\n\n                    .sidebar-header {\n                        padding: 1.5rem 2rem;\n                        justify-content: space-between;\n                        height: 5.71rem;\n                        .app-logo {\n                            text-align: left;\n                            .app-logo-normal {\n                                height: auto;\n                                width: 100%;\n                                max-width: none;\n                                img {\n                                    &:first-child{\n                                        width: 32px;\n                                        max-width: none;\n                                    }\n                                    &:last-child{\n                                        width: 142px;\n                                        max-width: none;\n                                    }\n                                }\n                            }\n\n                            .app-logo-small {\n                                display: none;\n                            }\n                        }\n\n                        .layout-sidebar-anchor {\n                            display: block;\n                            animation: px-fadein 0.15s linear;\n                        }\n                    }\n\n                    .layout-menu {\n                        padding: 0 1rem;\n\n                        li {\n                            border-radius: 8px;\n                            a {\n                                border-left: 8px solid transparent;\n                            }\n                        }\n                        li.active-menuitem {\n                            background-color: var(--root-menu-item-hover-bg);\n                            > a {\n                                border-left-color: var(--primary-color);\n                                background-color: var(--root-menu-item-hover-bg);\n                                .layout-submenu-toggler {\n                                    transform: rotate(-180deg);\n                                }\n                            }\n                        }\n                        a {\n                            user-select: none;\n\n                            &.active-menuitem {\n                                > .layout-submenu-toggler {\n                                    transform: rotate(-180deg);\n                                }\n                            }\n                        }\n                        .layout-root-menuitem {\n                            > div {\n                                padding-left: 1.5rem;\n                                margin-bottom: 0.5rem;\n                                font-size: 12px;\n                                opacity: 1;\n                                > .layout-menuitem-text {\n                                    font-size: 0.857rem;\n                                    opacity: 1;\n                                    font-weight: 600;\n                                    text-transform: uppercase;\n                                }\n                            }\n                        }\n\n                        ul {\n                            width: auto;\n                            li {\n                                width: auto;\n                            }\n                            a {\n                                width: auto;\n\n                                .layout-submenu-toggler {\n                                    display: block;\n                                }\n\n                                span {\n                                    opacity: 1;\n                                    white-space: nowrap;\n                                    transition: all 0.3s;\n                                }\n                            }\n                            ul {\n                                overflow: hidden;\n                                border-radius: var(--border-radius);\n\n                                li {\n                                    a {\n                                        padding-left: 2.5rem;\n                                    }\n\n                                    li {\n                                        a {\n                                            padding-left: 3rem;\n                                        }\n\n                                        li {\n                                            a {\n                                                padding-left: 3.5rem;\n                                            }\n\n                                            li {\n                                                a {\n                                                    padding-left: 4rem;\n                                                }\n\n                                                li {\n                                                    a {\n                                                        padding-left: 5.5rem;\n                                                    }\n\n                                                    li {\n                                                        a {\n                                                            padding-left: 5rem;\n                                                        }\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.layout-sidebar-anchored {\n                .sidebar-header {\n                    .layout-sidebar-anchor {\n                        background-color: var(--primary-color);\n                    }\n                }\n\n                .layout-content-wrapper {\n                    margin-left: 22rem;\n                }\n            }\n        }\n    }\n}\n","@media screen and (min-width: $breakpoint) {\n    .layout-container {\n        &.layout-static {\n            .layout-sidebar {\n                transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);\n            }\n\n            .layout-content-wrapper {\n                margin-left: 17rem;\n                transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);\n            }\n        }\n\n        &.layout-static-inactive {\n            .layout-sidebar {\n                transform: translateX(-100%);\n            }\n\n            .layout-content-wrapper {\n                margin-left: 0;\n            }\n        }\n\n        &.layout-overlay {\n            .layout-content-wrapper {\n                margin-left: 0;\n            }\n\n            .layout-sidebar {\n                z-index: 999;\n                transform: translateX(-100%);\n                transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);\n                background: var(--surface-ground);\n            }\n\n            &.layout-overlay-active {\n                .layout-sidebar {\n                    transform: translateX(0);\n                }\n            }\n        }\n\n        .content-breadcrumb {\n            display: none;\n        }\n    }\n}\n\n@media screen and (max-width: ($breakpoint - 1)) {\n    .blocked-scroll {\n        overflow: hidden;\n    }\n\n    .layout-topbar {\n        .topbar-menu {\n            margin-right: 0rem !important;\n        }\n\n        .right-panel-button {\n            position: absolute !important;\n            right: 0;\n        }\n    }\n\n    .layout-container {\n\n        .layout-content-wrapper {\n            margin-left: 0;\n            padding: 1rem;\n        }\n\n        .layout-sidebar {\n            z-index: 999;\n            transform: translateX(-100%);\n            transition: transform var(--transition-duration);\n            box-shadow: none;\n        }\n\n        &.layout-mobile-active {\n            .layout-sidebar {\n                transform: translateX(0);\n                background: var(--surface-ground);\n            }\n\n            .layout-mask {\n                display: block;\n                animation: fadein var(--transition-duration);\n            }\n        }\n\n        .layout-mask {\n            display: none;\n            position: fixed;\n            top: 0;\n            left: 0;\n            z-index: 998;\n            width: 100%;\n            height: 100%;\n            background-color: var(--maskbg);\n        }\n\n        .topbar-breadcrumb {\n            display: none;\n        }\n\n        .content-breadcrumb {\n            display: block;\n        }\n\n\n    }\n\n}\n\n@media screen and (min-width: 1960px) {\n\n    .layout-content,\n    .landing-wrapper {\n        // width: 1504px;\n        margin-left: auto !important;\n        margin-right: auto !important;\n    }\n\n    .layout-topbar {\n        width: 1504px;\n        margin-left: auto !important;\n        margin-right: auto !important;\n\n        .topbar-menu {\n            margin-right: 0rem !important;\n        }\n\n        .right-panel-button {\n            position: absolute !important;\n            right: 0;\n        }\n    }\n}",".layout-rightmenu-button {\n    background: linear-gradient(271.89deg, rgba(70,82,104,1), rgba(115,130,161,1));\n    border-radius: 6px 0px 0px 6px;\n    border-color: transparent;\n    border-left: 0 none;\n    box-shadow: 0px 0px 10px rgb(15 139 253 / 25%);\n    right: 0;\n    color: #fff;\n    span {\n        font-weight: 400 !important;\n    }\n    &:enabled:hover {\n        background: linear-gradient(271.89deg, rgba(70,82,104,0.5), rgba(115,130,161,0.5));\n        border-color: transparent;\n    }\n}\n.layout-topbar {\n    margin-bottom: 2rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .topbar-start {\n        display: flex;\n        align-items: center;\n        position: relative;\n        z-index: 999;\n        .topbar-menubutton {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 2rem;\n            border-radius: var(--border-radius);\n            width: 2.5rem;\n            height: 2.5rem;\n            flex-shrink: 0;\n            transition: background-color var(--transition-duration);\n\n            i {\n                font-size: 1.25rem;\n                color: var(--text-color);\n                transition: color var(--transition-duration);\n            }\n\n            &:hover {\n                background-color: var(--primary-color);\n\n                i {\n                    color: var(--primary-color-text);\n                }\n            }\n        }\n    }\n\n    .topbar-menu {\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        margin: 0;\n        padding: 0 1.15rem 0 0.85rem;\n        padding-right: 0;\n        list-style: none;\n        flex-grow: 1;\n        color: var(--topbar-item-text-color);\n        margin-right: -2rem;\n\n        li {\n            margin-left: 1.5rem;\n            &.topbar-item {\n                margin-left: 1.5rem;\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                position: relative;\n\n                img {\n                    width: 2rem;\n                    height: 2rem;\n                }\n\n                button {\n                    border-radius: 50%;\n                    width: 2rem;\n                    height: 2rem;\n                    transition: box-shadow var(--transition-duration);\n\n                    &:focus {\n                        box-shadow: var(--focus-ring);\n                    }\n                }\n\n                ul {\n                    position: absolute;\n                    bottom: -9.4rem;\n                    right: 0;\n                    display: none;\n                    color: var(--text-color);\n                    background: var(--surface-ground);\n                    box-shadow: var(--box-shadow);\n                    &.active-topbar-menu {\n                        display: block;\n                    }\n\n                    a {\n                        color: var(--text-color);\n                    }\n\n\n                   \n                }\n            }\n            .topbar-search {\n                display: flex;\n                align-items: center;\n                flex-shrink: 0;\n                .topbar-searchbutton {\n                   display: flex;\n                }\n        \n                .search-input-wrapper {\n                    position: relative;\n                    width: 0;\n                    opacity: 0;\n                    visibility: hidden;\n                    transition: 400ms cubic-bezier(0.86, 0, 0.07, 1);\n        \n                    span {\n                        width: 100%;\n        \n                        .p-inputtext {\n                            width: 100%;\n                            position: relative;\n                            border-radius: 40px;\n                            padding: 9px;\n                        }\n        \n                        i {\n                            font-size: 18px;\n                            margin-top: -9px;\n                        }\n                    }\n                }\n        \n                &.topbar-search-active {\n                    .topbar-searchbutton {\n                        opacity: 0;\n                        display: none;\n                        pointer-events: none;\n                        cursor: default;\n                        transition: opacity .1s;\n                        transition-delay: .1s;\n                    }\n                    \n                    .search-input-wrapper {\n                        width: 190px;\n                        opacity: 1;\n                        visibility: visible;\n                        border-radius: var(--border-radius);\n                        i {\n                            display: block;\n                        }\n                        input{\n                            border-radius: var(--border-radius);\n                        }\n                    }\n                }\n            }\n\n            button {\n                span {\n                    color: var(--item-text-color);\n                }\n            }\n          \n        }\n    }\n}\n\n",".layout-breadcrumb {\n    ol {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n        gap: 1rem;\n        flex-wrap: wrap;\n        color: var(--text-color-secondary);\n\n        li {\n            font-weight: 600;\n        }\n    }\n    .breadcrumb-menu {\n        margin: 0;\n        padding: 0 1.15rem 0 0.85rem;\n        padding-right: 0;\n        list-style: none;\n        flex-grow: 1;\n        color: var(--topbar-item-text-color);\n        margin-right: -2rem;\n\n        li {\n            margin-left: 1.5rem;\n            .breadcrumb-search {\n                display: flex;\n                align-items: center;\n                flex-shrink: 0;\n                width: 100%;\n                margin-left: 0rem;\n\n                .breadcrumb-searchbutton {\n                    display: flex;\n                    opacity: 1;\n                }\n\n                .search-input-wrapper {\n                    position: relative;\n                    width: 0;\n                    opacity: 0;\n                    visibility: hidden;\n                    transition: 400ms cubic-bezier(0.86, 0, 0.07, 1);\n\n                    span {\n                        width: 100%;\n\n                        .p-inputtext {\n                            width: 100%;\n                            position: relative;\n                            border-radius: 40px;\n                            padding: 9px;\n                        }\n\n                        i {\n                            font-size: 18px;\n                            margin-top: -9px;\n                            margin-right: 9px;\n                        }\n                    }\n                }\n\n                &.breadcrumb-search-active {\n                    .breadcrumb-searchbutton {\n                        opacity: 0;\n                        display: none;\n                        pointer-events: none;\n                        cursor: default;\n                    }\n\n                    .search-input-wrapper {\n                        width: 100%;\n                        opacity: 1;\n                        visibility: visible;\n                        border-radius: var(--border-radius);\n                        i {\n                            display: block;\n                        }\n                        .p-input-icon-right {\n                            input {\n                                border-radius: var(--border-radius);\n                                width: 100%;\n                                background: var(--surface-ground);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.content-breadcrumb {\n    margin-bottom: 2rem;\n    padding: 0 0.5rem;\n}\n",".layout-profile-sidebar {\n    &.p-sidebar {\n        width: 25rem;\n\n        .p-sidebar-content {\n            padding-left: 2rem;\n            padding-right: 2rem;\n        }\n    }\n}",".layout-config-button {\n    display: block;\n    position: fixed;\n    width: 3rem;\n    height: 3rem;\n    line-height: 3rem;\n    background: var(--primary-color);\n    color: var(--primary-color-text);\n    text-align: center;\n    top: 50%;\n    right: 0;\n    margin-top: -1.5rem;\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    transition: background-color var(--transition-duration);\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 999;\n    box-shadow: -.25rem 0 1rem rgba(0,0,0,.15);\n\n    i {\n        font-size: 2rem;\n        line-height: inherit;\n        transform: rotate(0deg);\n        transition: transform 1s;\n    }\n\n    &:hover {\n        background: var(--primary-400);\n    }\n}\n\n.layout-config-sidebar {\n    &.p-sidebar {\n        .p-sidebar-content {\n            padding-left: 2rem;\n            padding-right: 2rem;\n        }\n    }\n}",".layout-content-wrapper {\n    padding: 2rem 2rem 0rem 2rem;\n}","h1, h2, h3, h4, h5, h6 {\n    margin: 1.5rem 0 1rem 0;\n    font-family: inherit;\n    font-weight: 600;\n    line-height: 1.2;\n\n    &:first-child {\n        margin-top: 0;\n    }\n}\n\nh1 {\n    font-size: 2.5rem;\n}\n\nh2 {\n    font-size: 2rem;\n}\n\nh3 {\n    font-size: 1.75rem;\n}\n\nh4 {\n    font-size: 1.5rem;\n}\n\nh5 {\n    font-size: 1.25rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\nmark {\n    background: #FFF8E1;\n    padding: .25rem .4rem;\n    border-radius: var(--border-radius);\n    font-family: monospace;\n}\n\nblockquote {\n    margin: 1rem 0;\n    padding: 0 2rem;\n    border-left: 4px solid #90A4AE;\n}\n\nhr {\n    border-top: solid var(--surface-border);\n    border-width: 1px 0 0 0;\n    margin: 1rem 0; \n}\n\np {\n    margin: 0 0 1rem 0;\n    line-height: 1.5;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}",".card {\n    border-radius: 8px;\n    background: var(--surface-card);\n    padding: 16px;\n    box-sizing: border-box;\n    margin-bottom: 16px;\n\n    .card-header {\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .card-subtitle {\n        color: var(--text-color-secondary);\n        font-size: 0.857rem;\n        font-weight: 500;\n        margin: -1rem 0 1rem 0;\n    }\n}\n\n.p-toast {\n    &.p-toast-top-right,\n    &.p-toast-top-left,\n    &.p-toast-top-center {\n        top: 70px;\n    }\n}\n\n.ng-hidden {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
